//#region src/canvas/i18n/messages/en.json
var en_default = {
	Workspace: {
		"edges": {
			"deleteConfirmTitle": "Delete connection?",
			"deleteConfirmDescription": "This connection isn't attached to any node. Delete it?",
			"delete": "Delete",
			"cancel": "Cancel"
		},
		"handles": {
			"text": "Text",
			"image": "Image",
			"image2": "Image 2",
			"images": "Images",
			"end_image": "End image",
			"video": "Video",
			"videos": "Videos",
			"audio": "Audio",
			"speech": "Speech",
			"ref_audio": "Reference audio",
			"ref_text": "Reference text",
			"document": "Document",
			"byFeature": { "image-image-gen-video": {
				"image": "First frame",
				"end_image": "Last frame"
			} }
		},
		"modeSwitch": {
			"createMode": "Create Mode",
			"executeMode": "Execute Mode",
			"appMode": "App Mode",
			"upgradeRequired": "Upgrade to unlock Execute Mode"
		},
		"appView": {
			"inputsTitle": "Inputs",
			"outputsTitle": "Results",
			"run": "Run",
			"cancel": "Stop",
			"stepProgress": "Step {current} of {total}",
			"completed": "Done",
			"failed": "Something went wrong",
			"emptyWorkflow": "The canvas is empty. Build a workflow first.",
			"invalidWorkflow": "This workflow has a cycle and can't run.",
			"nothingToRun": "This workflow has no runnable steps yet.",
			"noOutputsYet": "Results will show up here after a run.",
			"dropFilesHere": "Drop files here or click to upload",
			"copyText": "Copy",
			"download": "Download",
			"goToCreateMode": "Go to Create Mode",
			"textPlaceholder": "Type here…",
			"fieldType": {
				"text": "Text",
				"image": "Image",
				"audio": "Audio",
				"video": "Video",
				"model": "3D model",
				"file": "File"
			}
		},
		"smartIsland": {
			"category": {
				"digitalHuman": "Digital Human",
				"artDesign": "Art & Design",
				"videoAd": "Video & Ads",
				"docProcessing": "Doc Processing",
				"knowledgeLearning": "Knowledge Learning",
				"musicMV": "Music/MV"
			},
			"enterWorkflowName": "Enter workflow name",
			"saveSuccess": "Saved successfully!",
			"saveFailed": "Save failed, please try again",
			"generateVideo": "Generate Video",
			"generateAudio": "Generate Audio",
			"generateText": "Generate Text",
			"generateImage": "Generate Image",
			"generateMusic": "Generate Music",
			"generate3D": "Generate 3D",
			"detectPose": "Pose",
			"segmentBody": "Segment Body",
			"estimateNormal": "Normals",
			"extractForeground": "Matting",
			"captureMotion": "Motion Capture",
			"firstLastFrameVideo": "First/Last Frame Video",
			"confirmExecute": "Confirm Execute",
			"deployModalWorkers": "Deploy Modal Workers",
			"deployModalRunning": "Deploying Modal workers...",
			"deployModalSuccess": "Modal workers deployed",
			"deployModalFailed": "Modal deploy failed",
			"deployModalUnsupported": "This action is only available in the desktop app",
			"saveAndExecute": "Save and Execute",
			"cancel": "Cancel",
			"executeConfirmTitle": "Confirm Execute Workflow",
			"executeConfirmDescSaved": "The workflow will be saved with the latest state before execution. Confirm execution?",
			"executeConfirmDescNew": "Please save the workflow before execution. Generated materials will be associated with this workflow for future reference and management.",
			"executeWorkflow": "Execute Workflow",
			"saveWorkflow": "Save Workflow",
			"executing": "Executing...",
			"saving": "Saving...",
			"estimatedCost": "Estimated Cost:",
			"estimatedTime": "Estimated Time:",
			"workflowName": "Workflow Name",
			"workflowNamePlaceholder": "Enter workflow name",
			"workflowDescription": "Workflow Description",
			"workflowDescPlaceholder": "Enter workflow description (optional)",
			"tooltip3D": "3D",
			"tooltipDocument": "Document",
			"tooltipImage": "Image",
			"tooltipText": "Text",
			"tooltipVideo": "Video",
			"tooltipAudio": "Audio",
			"tooltipLink": "Link",
			"split": "Split",
			"splitText": "Smart Split",
			"speechRecognize": "Speech Recognition",
			"separateAudio": "Separate Vocals",
			"separateSpeaker": "Speaker Separation",
			"separateSound": "Extract Sound",
			"speakWithStyle": "Speak with Style",
			"denoise": "Denoise",
			"convertVoice": "Voice Replacement",
			"filter": "Filter",
			"arrange": "Arrange",
			"concat": "Concat",
			"describeReverse": "Describe",
			"upscale": "HD Upscale",
			"removeSubtitle": "Remove Subtitle",
			"removeWatermark": "Remove Watermark",
			"extractAudioTrack": "Extract audio track",
			"removeVideoAudio": "Remove audio",
			"slice": "Slice",
			"firstFrame": "First Frame",
			"lastFrame": "Last Frame",
			"editImage": "Edit Image",
			"editVideo": "Edit Video",
			"parseDocument": "Parse Document",
			"extractContent": "Extract Content",
			"mergeGroup": "Merge Group",
			"imageFusion": "Image Fusion",
			"imagesGenVideo": "Reference to Video",
			"refsGenVideo": "Omni Reference Video",
			"rewriteText": "Rewrite Text",
			"textToSpeech": "Text to Speech",
			"textToSpeechClone": "Generate Speech (Clone)",
			"textToSpeechPreset": "Generate Speech (Preset)",
			"textToSpeechInstruct": "Generate Speech (Describe)",
			"motionControl": "Motion Control",
			"videoTransfer": "Video Transfer",
			"characterReplace": "Character Replace",
			"merge": "Merge",
			"lipSync": "Lip Sync",
			"lipDub": "Lip Dub",
			"cloneVoice": "Clone Voice",
			"speechGenVideo": "Audio Generate Video",
			"repaintMusic": "Repaint",
			"coverMusic": "Cover",
			"extractStem": "Extract Stem",
			"addTrack": "Add Track",
			"completeMusic": "Complete",
			"musicBrief": "Music Brief"
		},
		"toast": {
			"executing": "Executing...",
			"completed": "Completed",
			"cancelled": "Cancelled",
			"cancelling": "Cancelling...",
			"failed": "Failed",
			"nodes": "Nodes",
			"cancelTask": "Cancel Task",
			"totalDuration": "Total Duration",
			"taskCompleted": "Task completed",
			"taskFailed": "Task failed",
			"taskFailedWithMsg": "Task failed: {error}",
			"level": "Level {level}"
		},
		"dialog": {
			"myWorkflows": "My Workflows",
			"noWorkflows": "No workflows",
			"savedWorkflowsHint": "Saved workflows will appear here",
			"noMore": "No more workflows",
			"loadSuccess": "Loaded successfully!",
			"loadFailed": "Load failed, please try again",
			"open": "Open"
		},
		"menu": {
			"save": "Save",
			"saveAs": "Save As",
			"clear": "Clear",
			"confirmClear": "Are you sure you want to clear the current workflow? This action cannot be undone.",
			"cleared": "Workflow cleared",
			"saveAsNew": "Save as new workflow",
			"saveWorkflow": "Save Workflow",
			"saveNew": "Save as new",
			"name": "Name",
			"enterName": "Enter workflow name",
			"descOptional": "Description (Optional)",
			"enterDesc": "Enter workflow description",
			"saving": "Saving...",
			"update": "Update",
			"cancel": "Cancel",
			"saveSuccess": "Saved successfully!",
			"saveFailed": "Save failed, please try again",
			"exportJson": "Export JSON",
			"exportWorkflow": "Export Workflow",
			"exportExecutable": "Export Executable",
			"importJson": "Import JSON",
			"importJsonInvalid": "Could not parse: invalid JSON or structure.",
			"importJsonNoCanvas": "This file has no canvas data (needs originalFlow, flow, or nodes/edges at the root).",
			"importJsonSuccess": "Loaded workflow ({nodes} nodes, {edges} edges)",
			"importJsonReadFailed": "Failed to read file",
			"exportJsonSuccess": "Download started",
			"exportJsonFailed": "Export failed, please try again"
		},
		"nodes": {
			"base": {
				"moreActions": "More options",
				"execute": "Execute",
				"cancelExecution": "Cancel execution",
				"removeComment": "Remove comment",
				"commentPlaceholder": "Add a comment for users...",
				"clickToAddComment": "Click to add a comment...",
				"addComment": "Add comment",
				"delete": "Delete",
				"deleteConfirmTitle": "Confirm Deletion",
				"deleteConfirmDescription": "This node has {count} downstream node(s). Please choose how to delete.",
				"deleteNodeOnly": "Delete this node only",
				"deleteNodeAndChildren": "Delete this node and all downstream nodes ({count})",
				"deleteChildrenOnly": "Delete downstream nodes only ({count})",
				"run": "Run",
				"preview": "Preview",
				"lock": "Lock Node",
				"unlock": "Unlock Node",
				"startCombo": "Start Combo",
				"addToCombo": "Add to Combo",
				"removeFromCombo": "Remove from Combo",
				"edit": "Edit",
				"cancel": "Cancel",
				"confirm": "Confirm",
				"fullscreenEdit": "Fullscreen Edit",
				"startVoice": "Start Voice Input",
				"stopVoice": "Stop Voice Input",
				"editText": "Edit Text",
				"select": "Select",
				"selected": "Selected",
				"modalNotDeployedTitle": "Modal app not deployed",
				"modalNotDeployedDescription": "Feature \"{feature}\" requires Modal app \"{app}\". It is not deployed yet. Deploy now?",
				"modalDeployHint": "1) Set MODAL_TOKEN_ID / MODAL_TOKEN_SECRET. 2) Ensure plugins/ is present; the server scans plugin annotations in memory. 3) Ensure `python -m modal` works (e.g. pip install modal), then use one-click deploy to run modal deploy on each plugin deploy.py from that registry.",
				"modalDeployDismiss": "Cancel",
				"modalDeployAction": "Download & deploy",
				"modalDeploying": "Deploying Modal workers…",
				"modalDeployDone": "Deployment completed",
				"modalDeployError": "Deployment failed",
				"modalDeployingAction": "Deploying…",
				"modalDeployProgressHint": "Deployed {done}/{total}",
				"pluginImplementationTitle": "Implementation",
				"pluginModelTitle": "Model",
				"pluginParamsTitle": "Advanced",
				"pluginParamsReset": "Reset",
				"pluginParamDefault": "default {value}",
				"pluginImplementationLoading": "Loading plugin implementations…",
				"pluginImplementationEmpty": "No plugin implementations were scanned for this capability. Add Modal or API plugins under the repo's plugins/ directory (see README), then reload this page.",
				"pluginRegistryLoadError": "Could not load the plugin registry: {message}",
				"pluginSelectPlaceholder": "Select a repo…",
				"missingImplTitle": "Missing Implementation",
				"missingImplDescription": "No plugin is installed for this node (or none is selected). Install one from the plugin manager, or pick an installed plugin, before running."
			},
			"common": {
				"enterInstructions": "Enter instructions...",
				"manualInput": "Input",
				"library": "Library",
				"addText": "Add Text",
				"enterText": "Enter text content...",
				"descOptional": "Description (Optional)",
				"fromUpstreamText": "From upstream text node",
				"videoDesc": "Video description",
				"aspectRatio": "Aspect Ratio",
				"resolution": "Resolution",
				"duration": "Duration",
				"currentSize": "Current Size:",
				"currentDuration": "Current Duration:",
				"upscaleTierLabel": "Output tier (long edge)",
				"upscaleTierHint": "Aspect ratio follows input; only the long edge is scaled.",
				"upscaleTier1k": "1K · ~1920",
				"upscaleTier2k": "2K · ~2560",
				"upscaleTier4k": "4K · ~3840",
				"seconds": "s",
				"minute": "min",
				"thinkingProcess": "Thinking Process",
				"performanceMode": "Performance Mode",
				"ecoMode": "💰 Eco Mode",
				"proMode": "⚡ Pro Mode",
				"modelSelect": "Model",
				"models": {
					"imageEdit": "FLUX2 Klein image edit",
					"imageGen": "Z-Image text-to-image",
					"imageFusion": "FLUX2 Klein image fusion",
					"imageGenVideo": "LTX2 image-to-video",
					"features": {
						"gen-text": "Default (OpenRouter)",
						"gen-text-gemini": "Gemini",
						"gen-text-openai": "OpenAI",
						"split-text": "Smart split",
						"combine-text": "Merge texts",
						"combine-text-openai": "Merge texts (OpenAI)",
						"combine-text-gemini": "Merge texts (Gemini)",
						"image-fusion": "FLUX2 Klein fusion",
						"image-gen-text": "Image captioning",
						"video-gen-text": "Video captioning",
						"transcribe": "Speech to text",
						"transcribe-timestamp": "Speech to text (with timestamps)",
						"concat-videos": "Concatenate videos",
						"extract-audio": "Extract audio track",
						"remove-video-audio": "Remove audio (silent video)",
						"merge-video-audio": "Mux audio + video",
						"get-first-frame": "First frame",
						"get-last-frame": "Last frame",
						"parse-document": "Document to text",
						"split-video": "Split by shots",
						"link": "Fetch from URL",
						"gen-video": "Text to video",
						"image-gen": "Z-Image text-to-image",
						"gen-music": "ACE-Step music",
						"text-gen-speech-preset": "TTS (preset style)",
						"image-gen-video": "Image to video",
						"image-edit": "FLUX2 Klein edit",
						"image-upscale": "Image upscale",
						"video-upscale": "Video upscale",
						"image-describe": "Image understanding",
						"video-describe": "Video understanding",
						"audio-describe": "Audio understanding",
						"music-repaint": "Music repaint",
						"music-cover": "Music cover",
						"music-extract": "Stem extraction",
						"music-lego": "Add track",
						"music-complete": "Arrangement completion",
						"music-brief": "Music brief",
						"audio-image-gen-video": "Speech+image to video",
						"speech-text-gen-video": "Speech+text to video",
						"video-image-gen-video-mix": "Video+image mix",
						"video-image-gen-video-move": "Video+image move",
						"image-image-gen-video": "Image+image to video",
						"text-gen-video": "Text to video",
						"image-gen-model": "Image to 3D",
						"speech-video-gen-video": "Video lip dub (text+video)",
						"audio-video-lip-sync": "Audio+video lip sync",
						"text-gen-speech-clone": "Voice clone TTS",
						"text-gen-speech-instruct": "Instruct TTS",
						"video-image-move-animal": "Video+image move (animal)",
						"video-image-move": "Video+image move (human)",
						"video-image-move-muti": "Video+image move (multi)",
						"video-image-move-animal-muti": "Video+image move (animal, multi)",
						"wan-animate-mix": "WAN animate mix",
						"subtitle-remove": "Subtitle removal",
						"remove-watermark": "Watermark removal",
						"denoise-audio": "Audio denoise",
						"separate-audio-track": "Vocal / accompaniment",
						"separate-speaker": "Speaker diarization",
						"convert-voice": "Voice replacement",
						"drop-video": "Filter clips",
						"arrange-group": "Arrange batch"
					}
				},
				"voice": "Voice",
				"selectVoice": "Select Voice",
				"previewVoice": "Preview Voice",
				"uploadVoice": "Upload Voice",
				"recordVoice": "Record Voice",
				"voiceClone": "Voice Clone",
				"voicePreset": "Preset Style",
				"voiceDescribe": "Custom Description",
				"gender": "Gender",
				"selectGender": "Select Gender (Optional)",
				"emotion": "Emotion",
				"style": "Style",
				"selectEmotion": "Select Emotion (Optional)",
				"selectStyle": "Select Style (Optional)",
				"voiceDescription": "Voice Description",
				"voiceDescriptionPlaceholder": "Enter voice style description, e.g.: A gentle and sweet female voice, speaking slowly...",
				"referenceAudio": "Reference Audio",
				"noReferenceAudio": "Upload or record a reference clip (≥3 s)",
				"referenceText": "Reference Text",
				"referenceTextPlaceholder": "Optional: transcript of the reference audio — improves clone quality",
				"referenceTextCloneHint": "Leave empty for fast x-vector clone; paste the reference transcript for higher-quality ICL clone",
				"language": "Language",
				"inputText": "Input Text"
			},
			"titles": {
				"imageGenVideo": "Image to Video",
				"textGenVideo": "Text to Video",
				"addText": "Add Text",
				"textGenText": "Text Generation",
				"combineText": "Combine Texts",
				"textGenImage": "Text to Image",
				"textGenSpeechClone": "Generate Speech (Clone)",
				"textGenSpeechCloneCompose": "Voice Clone (Text + Audio)",
				"imageGenVideoCompose": "Image to Video (Text + Image)",
				"textGenSpeechPreset": "Generate Speech (Preset)",
				"textGenSpeechInstruct": "Generate Speech (Describe)",
				"imageFusion": "Image Fusion",
				"videoUpscale": "Video Upscale",
				"videoGenText": "Describe Video",
				"speechRecognize": "Speech Recognition",
				"textGenMusic": "Text to Music",
				"speechGenVideo": "Audio to Video",
				"convertVoice": "Voice Replacement",
				"denoiseAudio": "Audio Denoise",
				"fileGenText": "Document Parser",
				"linkGenText": "Link Extractor",
				"removeSubtitle": "Remove Subtitle",
				"removeWatermark": "Remove Watermark",
				"separateAudio": "Split Audio & Video",
				"imageGenText": "Image Description",
				"audioDescribe": "Audio Description",
				"imageGenImage": "Image Edit",
				"videoEdit": "Video Edit",
				"imageGenModel": "Image to 3D Model",
				"imagePose": "Pose Detection",
				"imageBodySeg": "Body-Part Segmentation",
				"imageNormal": "Surface Normal",
				"imageMatting": "Human Matting",
				"videoGenModel": "Video Motion Capture",
				"imageUpscale": "HD Upscale",
				"separateTrack": "Vocal Extract",
				"separateSpeaker": "Speaker Separation",
				"separateSound": "Separate Sound",
				"speechImageGenVideo": "Speech+Image to Video",
				"concatVideo": "Concat Video",
				"mergeVideoAudio": "Merge Video Audio",
				"audioVideoLipSync": "Video Lip Sync",
				"speechTextGenVideo": "Speech+Text to Video",
				"speechVideoGenVideo": "Video Lip Dub",
				"imageImageGenVideo": "First/Last Frame Video",
				"imagesGenVideo": "Images to Video",
				"refsGenVideo": "Omni Reference to Video",
				"textAudioGenSpeech": "Text+Audio to Speech",
				"videoImageMix": "Video+Image Mix",
				"videoImageMove": "Video+Image Move",
				"splitVideo": "Split Video",
				"splitText": "Smart Split",
				"getFirstFrame": "First Frame",
				"getLastFrame": "Last Frame",
				"extractAudioTrack": "Extract audio track",
				"removeVideoAudio": "Remove audio (silent video)",
				"musicRepaint": "Repaint Music",
				"musicCover": "Music Cover",
				"musicExtract": "Extract Stem",
				"musicLego": "Add Track",
				"musicComplete": "Complete Arrangement",
				"musicBrief": "Music Brief",
				"textGenAudio": "Text to Audio"
			},
			"options": {
				"portrait": "Portrait",
				"landscape": "Landscape",
				"square": "Square",
				"standard": "Standard",
				"verticalStandard": "Vertical Standard",
				"human": "Human",
				"animal": "Animal",
				"single": "Single",
				"multi": "Multi"
			},
			"actions": {
				"generateVideo": "Generate Video",
				"generateImage": "Generate Image",
				"generateSpeech": "Generate Speech",
				"startFusion": "Start Fusion",
				"convertText": "Convert to Text",
				"startUpscale": "Start Upscale",
				"describeVideo": "Describe Video",
				"recognizeSpeech": "Recognize Speech",
				"generateMusic": "Generate Music",
				"generateAudio": "Generate Audio",
				"startReplace": "Start Replace",
				"startDenoise": "Start Denoise",
				"parseDocument": "Parse Document",
				"extractContent": "Extract Content",
				"removeSubtitle": "Remove Subtitle",
				"removeWatermark": "Remove Watermark",
				"compressVideo": "Compress Video",
				"extractAudio": "Start Split",
				"describeImage": "Describe Image",
				"describeAudio": "Describe Audio",
				"editImage": "Edit Image",
				"editVideo": "Edit Video",
				"generate3DModel": "Generate 3D Model",
				"detectPose": "Detect Pose",
				"segmentBody": "Segment Body Parts",
				"estimateNormal": "Estimate Normals",
				"extractForeground": "Extract Foreground",
				"captureMotion": "Capture Motion",
				"imageUpscale": "HD Upscale",
				"extractVocals": "Extract Vocals",
				"startSeparation": "Start Separation",
				"concatVideo": "Concat Video",
				"startMerge": "Start Merge",
				"lipDub": "Lip Dub",
				"motionTrackGenerate": "Generate (motion track)",
				"splitVideo": "Split Video",
				"splitText": "Smart Split",
				"getFirstFrame": "Get First Frame",
				"getLastFrame": "Get Last Frame",
				"extractAudioTrack": "Extract audio",
				"removeVideoAudio": "Remove audio",
				"repaintMusic": "Repaint",
				"coverMusic": "Generate Cover",
				"extractStem": "Extract",
				"separateSound": "Separate",
				"addTrack": "Generate Track",
				"completeMusic": "Complete",
				"musicBrief": "Generate Brief"
			},
			"params": {
				"prompt": "Prompt",
				"model": "Model",
				"modelDefault": "Default (OpenRouter free)",
				"geminiModel": "Gemini model",
				"openaiModel": "OpenAI model",
				"style": "Style",
				"sampler": "Sampler",
				"seed": "Seed",
				"steps": "Steps",
				"cfg": "CFG Scale"
			},
			"emotions": {
				"none": "None",
				"happy": "Happy",
				"angry": "Angry",
				"sad": "Sad",
				"fear": "Fear",
				"surprised": "Surprised",
				"confusion": "Confusion",
				"empathy": "Empathy",
				"embarrass": "Embarrassed",
				"excited": "Excited",
				"depressed": "Depressed",
				"admiration": "Admiration",
				"coldness": "Coldness"
			},
			"genders": {
				"none": "None",
				"male": "Male",
				"female": "Female"
			},
			"styles": {
				"none": "None",
				"serious": "Serious",
				"arrogant": "Arrogant",
				"child": "Child",
				"older": "Older",
				"girl": "Girl",
				"pure": "Pure",
				"sister": "Mature Female",
				"sweet": "Sweet",
				"exaggerated": "Exaggerated",
				"ethereal": "Ethereal",
				"whisper": "Whisper",
				"generous": "Generous",
				"recite": "Recite",
				"act_coy": "Coquettish",
				"warm": "Warm",
				"shy": "Shy",
				"comfort": "Comforting",
				"authority": "Authoritative",
				"chat": "Chat",
				"radio": "Radio",
				"soulful": "Soulful",
				"gentle": "Gentle",
				"story": "Storytelling",
				"vivid": "Vivid",
				"program": "Host",
				"news": "News",
				"advertising": "Advertising",
				"roar": "Roar",
				"murmur": "Murmur",
				"shout": "Shout",
				"deeply": "Deep",
				"loudly": "Loud"
			},
			"recorder": {
				"title": "Record Voice",
				"desc": "Record an audio clip as a reference for voice synthesis",
				"start": "Start Recording",
				"stop": "Stop Recording",
				"preview": "Preview",
				"retry": "Retry",
				"uploading": "Uploading...",
				"confirm": "Confirm",
				"cancel": "Cancel",
				"recording": "Recording...",
				"recorded": "Recording Complete",
				"micError": "Cannot access microphone, please check permissions",
				"uploadError": "Upload failed, please try again",
				"uploadFailed": "Upload Failed"
			},
			"imageFusion": {
				"loading": "Loading...",
				"imageReference": "Image Reference",
				"imageReferenceHint": "Click image to insert reference in prompt",
				"fusionPrompt": "Fusion Prompt",
				"fusionPromptPlaceholder": "Enter fusion instructions, e.g., keep style of Image 1, fuse features of all images, highlight colors of Image 2, combine composition of Image 3...",
				"imageLabel": "Image"
			},
			"refsGenVideo": {
				"videoReference": "Video Reference",
				"videoLabel": "Video",
				"audioReference": "Audio Reference",
				"audioLabel": "Audio",
				"referenceHint": "Up to 9 images, 3 videos and 3 audio clips (12 files total); audio must come with an image or video. Click a thumbnail to insert its reference in the prompt.",
				"promptPlaceholder": "Describe the video, e.g., the character from Image 1 speaks with the voice of Audio 1, continuing the scene of Video 1..."
			},
			"video": { "fileCount": "Files to process:" },
			"speechRecognize": { "withTimestamp": "With Timestamp" },
			"music": {
				"handleStyle": "Style",
				"handleLyric": "Lyrics",
				"referenceAudio": "Reference audio",
				"inputLyrics": "Input Lyrics",
				"audioDuration": "Audio Duration",
				"currentDuration": "Current Duration:",
				"seconds": "s",
				"15s": "15s",
				"30s": "30s",
				"1min": "1 min",
				"2min": "2 min",
				"styleSettings": "Music Style",
				"voiceGender": "Voice",
				"genders": {
					"male": "Male",
					"female": "Female"
				},
				"timbre": "Timbre",
				"timbres": {
					"bright": "Bright",
					"dark": "Dark",
					"warm": "Warm",
					"soft": "Soft",
					"rock": "Rock",
					"vocal": "Vocal"
				},
				"genre": "Genre",
				"genres": {
					"pop": "Pop",
					"rock": "Rock",
					"electronic": "Electronic",
					"hiphop": "Hip Hop",
					"jazz": "Jazz",
					"blues": "Blues",
					"classical": "Classical",
					"folk": "Folk",
					"country": "Country",
					"rnb": "R&B",
					"kpop": "K-Pop",
					"reggae": "Reggae",
					"soul": "Soul",
					"dance": "Dance",
					"rap": "Rap",
					"classicRock": "Classic Rock",
					"hardRock": "Hard Rock",
					"rockabilly": "Rockabilly",
					"dancepop": "Dance Pop",
					"house": "House",
					"deephouse": "Deep House",
					"experimental": "Experimental",
					"experimentalPop": "Experimental Pop",
					"popPunk": "Pop Punk",
					"rockAndRoll": "Rock and Roll",
					"popRock": "Pop Rock"
				},
				"mood": "Mood",
				"moods": {
					"happy": "Happy",
					"sad": "Sad",
					"romantic": "Romantic",
					"melancholic": "Melancholic",
					"uplifting": "Uplifting",
					"intense": "Intense",
					"emotional": "Emotional",
					"angry": "Angry"
				},
				"instrumentAndRhythm": "Instrument & Rhythm",
				"instrument": "Instrument",
				"selectedCount": "{count} selected",
				"instruments": {
					"piano": "Piano",
					"guitar": "Guitar",
					"acousticGuitar": "Acoustic Guitar",
					"electricGuitar": "Electric Guitar",
					"drums": "Drums",
					"synthesizer": "Synthesizer",
					"violin": "Violin",
					"saxophone": "Saxophone",
					"bass": "Bass",
					"beats": "Beats",
					"strings": "Strings",
					"cello": "Cello",
					"trumpet": "Trumpet",
					"harmonica": "Harmonica",
					"banjo": "Banjo",
					"fiddle": "Fiddle",
					"brass": "Brass",
					"doubleBass": "Double Bass"
				},
				"bpm": "BPM",
				"slow": "Slow",
				"moderate": "Moderate",
				"fast": "Fast",
				"songTitle": "Song Title",
				"songTitlePlaceholder": "Enter song title (optional)",
				"noTagsSelected": "No tags selected",
				"tagsPlaceholder": "e.g. female, pop, bright, piano, happy, 120bpm",
				"tagsHint": "Enter music style tags separated by commas, e.g. gender, genre, timbre, instruments, mood, BPM",
				"fromUpstreamReadonly": "From upstream (read-only)",
				"lyricsPlaceholder": "Enter lyrics when the lyric input is not connected",
				"language": "Language",
				"keyscale": "Key Scale",
				"auto": "Auto"
			},
			"musicTasks": {
				"promptLabel": "Caption",
				"promptPlaceholder": "Describe the music style, mood, instruments...",
				"lyricsLabel": "Lyrics",
				"lyricsPlaceholder": "Lyrics (optional)...",
				"startTime": "Start (s)",
				"endTime": "End (s)",
				"strength": "Strength",
				"track": "Track",
				"tracks": "Tracks to add",
				"instrumental": "Instrumental",
				"ideaPlaceholder": "One sentence describing the song you want...",
				"sourceAudio": "Source Audio",
				"refAudio": "Reference Audio",
				"trackOptions": {
					"vocals": "Vocals",
					"backing_vocals": "Backing Vocals",
					"drums": "Drums",
					"percussion": "Percussion",
					"bass": "Bass",
					"guitar": "Guitar",
					"keyboard": "Keyboard",
					"synth": "Synth",
					"strings": "Strings",
					"brass": "Brass",
					"woodwinds": "Woodwinds",
					"fx": "FX"
				}
			},
			"speechGenVideo": {
				"loading": "Loading...",
				"inputContent": "Input Content",
				"audio": "Audio",
				"connectAudioHint": "Connect an audio node or upload an audio file",
				"audioPromptLabel": "Audio Prompt",
				"audioPromptPlaceholder": "Enter audio dubbing prompt"
			},
			"convertVoice": {
				"sourceAudio": "Source audio",
				"referenceVoice": "Reference voice",
				"connectHint": "Connect the audio to convert and a reference voice clip"
			},
			"removeWatermark": { "hint": "Automatically detect and remove Sora video watermarks" },
			"videoGenText": {
				"promptLabel": "Custom Prompt",
				"promptPlaceholder": "Leave empty for default prompt, or enter custom instructions, e.g.: Only describe the dialogues in the video..."
			},
			"imageGenText": {
				"promptLabel": "Custom Prompt",
				"promptPlaceholder": "Leave empty for default prompt, or enter custom instructions, e.g.: Describe the main subject, style, or on-image text..."
			},
			"audioDescribe": {
				"promptLabel": "Custom Prompt",
				"promptPlaceholder": "Leave empty for default prompt, or enter custom instructions, e.g.: Describe the genre, mood, instruments, or vocals..."
			},
			"textGenText": { "instructions": "Instructions" },
			"lipDub": {
				"targetDialogue": "Target dialogue (prompt)",
				"targetDialoguePlaceholder": "Full prompt with character description and target-language lines (model does not translate for you)",
				"promptHint": "Output resolution follows the reference video. Use a full prompt (character + target-language lines; no auto-translation). Match original clip length; single speaker only."
			},
			"lipSync": {
				"scenePrompt": "Scene description (optional)",
				"scenePromptPlaceholder": "Describe the shot and speaker. Lip sync follows the connected audio — do not paste full dialogue here.",
				"audioDrivenHint": "Mouth motion and audio come from the audio input. Keep audio duration close to the reference video. Default output 720p."
			},
			"motionTrack": {
				"connectHint": "Connect a first-frame image, a reference video (its motion is auto-tracked and transferred), and a text prompt (appearance/style only).",
				"controlVideo": "Reference video",
				"promptPlaceholder": "Describe appearance and style — motion is extracted from the reference video.",
				"promptHint": "Describe appearance/style only; motion is auto-extracted from the reference video. Duration slider caps the reference clip length.",
				"missing": "Still needed: {items}"
			},
			"imageEdit": {
				"performanceMode": "Performance Mode",
				"ecoMode": "💰 Eco (FLUX.2 Klein 9B)",
				"proMode": "⚡ Pro Mode",
				"editInstruction": "Edit Instruction",
				"fromUpstream": "(from upstream node)",
				"editPlaceholder": "Enter image edit instructions, e.g.: increase contrast, adjust color temperature to warm, enhance details"
			},
			"videoEdit": {
				"editInstruction": "Edit Instruction",
				"fromUpstream": "(from upstream node)",
				"editPlaceholder": "Enter video edit instructions, e.g.: remove subtitles, apply a watercolor style, change the sky to sunset",
				"connectTextVideo": "Connect a text node and a video node"
			},
			"compose": {
				"loading": "Loading...",
				"mediaFiles": "Media Files",
				"image": "Image",
				"audio": "Audio",
				"video": "Video",
				"text": "Text",
				"noText": "No Text",
				"inputContent": "Input Content",
				"videoFiles": "Video Files",
				"connectImageAudio": "Please connect an image and an audio file",
				"connectVideo": "Please connect at least one video file",
				"connectImageVideoAudio": "Please connect an image, a video and an audio file",
				"connectTextAudio": "Please connect text content and an audio file",
				"connectTextReferenceAudio": "Connect a text node and an audio node (reference voice)",
				"connectTextImage": "Connect a text node and an image node",
				"connectTextVideoNode": "Connect a video node and a text node (target dialogue goes in the prompt)",
				"referenceAudio": "Reference audio",
				"referenceTextOptional": "Reference transcript (optional, improves clone quality)",
				"connectVideoAudio": "Please connect a video and an audio file",
				"generatePromptLabel": "Generate Prompt",
				"generatePromptPlaceholder": "Enter video generation prompt describing content, style, action, etc. (optional)",
				"inputText": "Input Text",
				"inputTextPlaceholder": "Enter text content",
				"describeVideo": "Describe the video you want to generate...",
				"firstFrame": "First Frame",
				"lastFrame": "Last Frame",
				"connectTwoImages": "Please connect two images (first and last frame)",
				"inputData": "Input Data",
				"connectTextAudioNode": "Please connect text and audio nodes",
				"emotion": "Emotion:",
				"style": "Style:",
				"selectEmotion": "Select emotion style (optional)",
				"selectStyle": "Select voice style (optional)",
				"lipSync": "Lip Sync",
				"connectImageVideo": "Please connect an image and a video file",
				"startSlice": "Start Slice"
			},
			"modal": {
				"audioPreview": "Audio Preview",
				"audio": "Audio",
				"audios": "Audios ({count})",
				"loading": "Loading...",
				"unavailable": "Content unavailable",
				"more": "More",
				"moreOptions": "More options",
				"actions": "Actions",
				"textPreview": "Text Preview",
				"text": "Text",
				"texts": "Texts ({count})",
				"imagePreview": "Image Preview",
				"image": "Image",
				"images": "Images ({count})",
				"videoPreview": "Video Preview",
				"video": "Video",
				"videos": "Videos ({count})",
				"file": "File",
				"files": "Files ({count})",
				"link": "Link",
				"links": "Links ({count})",
				"fullScreenPreview": "Full screen preview",
				"fullScreenWaterfall": "Full screen waterfall preview",
				"model3DPreview": "3D Model Preview",
				"model3D": "3D Model",
				"models3D": "3D Models ({count})",
				"resetView": "Reset view",
				"playAnimation": "Play animation",
				"pauseAnimation": "Pause animation",
				"downloadModel": "Download model",
				"loading3DModel": "Loading 3D model...",
				"errorLoadingModel": "Error loading model",
				"dragToRotate": "Left Click + Drag to Rotate | Scroll to Zoom | Click Reset to Center",
				"noModelLoaded": "No 3D model loaded",
				"loadingPreview": "Loading preview...",
				"unsupportedFormat": "Unsupported Format",
				"supportedFormats": "Supported",
				"download": "Download",
				"textEditor": "Text Editor",
				"enterText": "Enter text content..."
			},
			"add": {
				"addAudio": "Add Audio",
				"addImage": "Add Image",
				"addVideo": "Add Video",
				"addText": "Add Text",
				"addFile": "Add File",
				"addModel": "Add 3D Model",
				"addLink": "Add Link",
				"record": "Record",
				"recordVideo": "Record Video",
				"upload": "Upload",
				"library": "Library",
				"recorded": "Recorded",
				"uploading": "Uploading",
				"confirmAndUpload": "Confirm & Upload",
				"dropToUpload": "Drop files to upload",
				"dragOrClick": "Drag files here or click to upload",
				"supportedAudioFormats": "Supports MP3, WAV, OGG, M4A",
				"supportedImageFormats": "Supports common image formats",
				"supportedVideoFormats": "Supports MP4, MOV, WEBM",
				"browseFiles": "Browse Files",
				"canvas": "Canvas",
				"camera": "Camera",
				"openCanvas": "Open Canvas",
				"canvasDrawing": "Canvas Drawing",
				"canvasDrawingHint": "Draw on the canvas below, then click finish to save",
				"clearCanvas": "Clear Canvas",
				"finishAndSave": "Finish & Save",
				"clickToStartCamera": "Click to Start Camera",
				"takePhoto": "Take Photo",
				"closeCamera": "Close Camera",
				"cameraError": "Cannot access camera",
				"cameraErrorHint": "Please ensure: 1. Using HTTPS or localhost 2. Camera permission allowed 3. Camera not in use by other apps",
				"inputText": "Input Text",
				"textPlaceholder": "Please enter text content...",
				"generate": "Confirm",
				"linkPlaceholder": "Please enter a link",
				"extractContent": "Extract Content",
				"cancel": "Cancel",
				"startRecordingVideo": "Start Recording Video",
				"addDocument": "Add Document",
				"supportedDocFormats": "Supports multiple document formats",
				"dragModel": "Drag 3D model files here or click to upload",
				"supportedModelFormats": "Supported formats",
				"modelHint": "Tip: Supports the following 3D file formats:"
			},
			"batch": {
				"arrangeGroup": "Arrange Groups",
				"startArrange": "Start Arrange",
				"describeRequirements": "Describe your requirements...",
				"groupCount": "Group Count",
				"allowDuplicate": "Allow Duplicates",
				"videoFilter": "Video Filter",
				"startFilter": "Start Filter"
			},
			"voice": {
				"timbre": "Voice:",
				"selectTimbre": "Select voice",
				"previewTimbre": "Preview current voice",
				"uploadTimbre": "Upload voice",
				"recordTimbre": "Record voice",
				"emotion": "Emotion:",
				"replaceTimbre": "Replace voice"
			},
			"separateSound": {
				"textLabel": "Sound to isolate",
				"textPlaceholder": "e.g. dog barking, piano, sirens in the background"
			},
			"textGenAudio": {
				"voiceReference": "Reference voices",
				"promptLabel": "Audio prompt",
				"promptPlaceholder": "Describe the whole scene: who speaks and how, background ambience, sound effects. Quote the lines, e.g. @voice1 says: \"It's sunny today.\" Rain patters on the window.",
				"hint": "One pass renders speech, sound effects and ambience together. Connect up to 3 audio clips as reference voices and click one to insert @voice1…@voice3."
			}
		}
	},
	Upload: {
		"failed": "Upload failed, please retry later",
		"fileFailed": "Failed to upload \"{name}\": {reason}",
		"partialFailed": "Some or all files failed to upload",
		"maxFilesExceeded": "Maximum {max} files allowed",
		"fileTooLarge": "File \"{name}\" is too large (max {max}MB)",
		"fileTypeNotAccepted": "File \"{name}\" type not accepted",
		"readImageFailed": "Failed to read image information",
		"readVideoFailed": "Failed to read video information"
	},
	LibInput: {
		"deleteSuccess": "Material deleted",
		"deleteFailed": "Failed to delete",
		"emptyText": "Empty text",
		"loadFailed": "Failed to load materials",
		"added": "Material added",
		"retry": "Retry",
		"emptyMaterial": "No {type} materials yet",
		"typeImage": "image",
		"typeVideo": "video",
		"typeAudio": "audio",
		"typeText": "text",
		"typeFile": "file",
		"typeModel": "model",
		"favoriteHint": "Click the ❤️ icon on a node to favorite the material",
		"portfolio": "Portfolio"
	},
	Recorder: {
		"audioStart": "Start recording",
		"audioCancel": "Cancel",
		"audioCancelTooltip": "Cancel recording",
		"audioFinish": "Finish",
		"audioFinishTooltip": "Finish recording",
		"audioPermissionError": "Cannot access microphone. Please grant permission.",
		"videoPermissionError": "Cannot access camera or microphone. Please grant permission.",
		"videoStart": "Start recording",
		"videoStop": "Stop recording"
	},
	Languages: {
		"auto": "Auto",
		"zh": "Chinese",
		"ja": "Japanese",
		"yue": "Cantonese",
		"en": "English",
		"ko": "Korean",
		"fr": "French",
		"es": "Spanish",
		"de": "German",
		"ru": "Russian",
		"pt": "Portuguese",
		"it": "Italian"
	},
	Errors: {
		"somethingWentWrong": "Something went wrong",
		"tryAgain": "Try again",
		"details": "Details",
		"copy": "Copy",
		"copied": "Copied",
		"close": "Close",
		"openModalBilling": "Open Modal billing",
		"needHelp": "Stuck? Come find us:",
		"wechatGroup": "WeChat group",
		"wechatQrAlt": "WeChat group QR code"
	},
	Api: {
		"unknownError": "Unknown error",
		"unauthorized": "Unauthorized",
		"accessDenied": "Access denied",
		"requestFailed": "Request failed: {status} {statusText}",
		"success": "Success",
		"timedOut": "Request timed out; please retry"
	}
};
//#endregion
//#region src/canvas/i18n/messages/ja.json
var ja_default = {
	Workspace: {
		"edges": {
			"deleteConfirmTitle": "接続を削除しますか？",
			"deleteConfirmDescription": "この接続はどのノードにも接続されていません。削除しますか？",
			"delete": "削除",
			"cancel": "キャンセル"
		},
		"handles": {
			"text": "テキスト",
			"image": "画像",
			"image2": "画像 2",
			"images": "画像",
			"end_image": "終了画像",
			"video": "動画",
			"videos": "動画",
			"audio": "音声",
			"speech": "音声",
			"ref_audio": "参照音声",
			"ref_text": "参照テキスト",
			"document": "ドキュメント",
			"byFeature": { "image-image-gen-video": {
				"image": "開始フレーム",
				"end_image": "終了フレーム"
			} }
		},
		"modeSwitch": {
			"createMode": "作成モード",
			"executeMode": "実行モード",
			"appMode": "アプリモード",
			"upgradeRequired": "実行モードを解除するにはアップグレードが必要です"
		},
		"appView": {
			"inputsTitle": "入力",
			"outputsTitle": "結果",
			"run": "実行",
			"cancel": "停止",
			"stepProgress": "ステップ {current}/{total}",
			"completed": "完了",
			"failed": "実行に失敗しました",
			"emptyWorkflow": "キャンバスが空です。まずワークフローを作成してください",
			"invalidWorkflow": "ワークフローに循環があるため実行できません",
			"nothingToRun": "このワークフローには実行できるステップがありません",
			"noOutputsYet": "実行すると結果がここに表示されます",
			"dropFilesHere": "ここにファイルをドロップ、またはクリックしてアップロード",
			"copyText": "コピー",
			"download": "ダウンロード",
			"goToCreateMode": "作成モードへ",
			"textPlaceholder": "ここに入力…",
			"fieldType": {
				"text": "テキスト",
				"image": "画像",
				"audio": "音声",
				"video": "動画",
				"model": "3Dモデル",
				"file": "ファイル"
			}
		},
		"smartIsland": {
			"category": {
				"digitalHuman": "デジタルヒューマン",
				"artDesign": "アート＆デザイン",
				"videoAd": "動画＆広告",
				"docProcessing": "ドキュメント処理",
				"knowledgeLearning": "知識学習",
				"musicMV": "音楽/MV"
			},
			"enterWorkflowName": "ワークフロー名を入力",
			"saveSuccess": "保存しました！",
			"saveFailed": "保存に失敗しました。もう一度お試しください",
			"generateVideo": "動画生成",
			"generateAudio": "オーディオ生成",
			"generateText": "テキスト生成",
			"generateImage": "画像生成",
			"generateMusic": "音楽生成",
			"generate3D": "3D生成",
			"detectPose": "ポーズ",
			"segmentBody": "身体分割",
			"estimateNormal": "法線",
			"extractForeground": "マッティング",
			"captureMotion": "モーションキャプチャ",
			"firstLastFrameVideo": "始点/終点フレーム動画",
			"confirmExecute": "実行を確認",
			"deployModalWorkers": "Modal ワーカーをデプロイ",
			"deployModalRunning": "Modal ワーカーをデプロイ中...",
			"deployModalSuccess": "Modal ワーカーのデプロイ完了",
			"deployModalFailed": "Modal のデプロイに失敗しました",
			"deployModalUnsupported": "この操作はデスクトップ版のみ対応しています",
			"saveAndExecute": "保存して実行",
			"cancel": "キャンセル",
			"executeConfirmTitle": "ワークフローの実行を確認",
			"executeConfirmDescSaved": "実行前にワークフローは最新の状態で保存されます。実行しますか？",
			"executeConfirmDescNew": "実行前にワークフローを保存してください。生成された素材は、将来の参照と管理のためにこのワークフローに関連付けられます。",
			"executeWorkflow": "ワークフローを実行",
			"saveWorkflow": "ワークフローを保存",
			"executing": "実行中...",
			"saving": "保存中...",
			"estimatedCost": "推定コスト：",
			"estimatedTime": "推定時間：",
			"workflowName": "ワークフロー名",
			"workflowNamePlaceholder": "ワークフロー名を入力",
			"workflowDescription": "ワークフローの説明",
			"workflowDescPlaceholder": "ワークフローの説明を入力（任意）",
			"tooltip3D": "3D",
			"tooltipDocument": "ドキュメント",
			"tooltipImage": "画像",
			"tooltipText": "テキスト",
			"tooltipVideo": "動画",
			"tooltipAudio": "音声",
			"tooltipLink": "リンク",
			"split": "分割",
			"splitText": "スマート分割",
			"speechRecognize": "音声認識",
			"separateAudio": "ボーカル分離",
			"separateSpeaker": "話者分離",
			"separateSound": "音を抽出",
			"speakWithStyle": "感情付き音声",
			"denoise": "ノイズ除去",
			"convertVoice": "音声置換",
			"filter": "フィルター",
			"arrange": "配置",
			"concat": "結合",
			"describeReverse": "説明生成",
			"upscale": "HD高画質化",
			"removeSubtitle": "字幕削除",
			"removeWatermark": "透かし削除",
			"extractAudioTrack": "音声抽出",
			"removeVideoAudio": "音声を除去",
			"slice": "スライス",
			"firstFrame": "最初のフレーム",
			"lastFrame": "最後のフレーム",
			"editImage": "画像編集",
			"editVideo": "動画編集",
			"parseDocument": "ドキュメント解析",
			"extractContent": "コンテンツを抽出",
			"mergeGroup": "グループ化",
			"imageFusion": "画像合成",
			"imagesGenVideo": "参照から動画",
			"refsGenVideo": "マルチ参照動画",
			"rewriteText": "テキストリライト",
			"textToSpeech": "テキスト読み上げ",
			"textToSpeechClone": "音声生成（クローン）",
			"textToSpeechPreset": "音声生成（プリセット）",
			"textToSpeechInstruct": "音声生成（説明）",
			"motionControl": "モーション制御",
			"videoTransfer": "動画転送",
			"characterReplace": "キャラクター置換",
			"merge": "結合",
			"lipSync": "リップシンク",
			"lipDub": "吹き替え・口パク",
			"cloneVoice": "ボイスクローン",
			"speechGenVideo": "音声から動画生成",
			"repaintMusic": "リペイント",
			"coverMusic": "カバー",
			"extractStem": "ステム抽出",
			"addTrack": "トラック追加",
			"completeMusic": "編曲補完",
			"musicBrief": "音楽ブリーフ"
		},
		"toast": {
			"executing": "実行中...",
			"completed": "完了",
			"cancelled": "キャンセル済み",
			"cancelling": "キャンセル中...",
			"failed": "失敗",
			"nodes": "ノード",
			"cancelTask": "タスクをキャンセル",
			"totalDuration": "合計時間",
			"taskCompleted": "タスク完了",
			"taskFailed": "タスク失敗",
			"taskFailedWithMsg": "タスク失敗：{error}",
			"level": "レベル {level}"
		},
		"dialog": {
			"myWorkflows": "マイワークフロー",
			"noWorkflows": "ワークフローがありません",
			"savedWorkflowsHint": "保存したワークフローがここに表示されます",
			"noMore": "これ以上ワークフローはありません",
			"loadSuccess": "読み込みました！",
			"loadFailed": "読み込みに失敗しました。もう一度お試しください",
			"open": "開く"
		},
		"menu": {
			"save": "保存",
			"saveAs": "名前を付けて保存",
			"clear": "クリア",
			"confirmClear": "現在のワークフローをクリアしてもよろしいですか？この操作は元に戻せません。",
			"cleared": "ワークフローをクリアしました",
			"saveAsNew": "新規ワークフローとして保存",
			"saveWorkflow": "ワークフローを保存",
			"saveNew": "新規として保存",
			"name": "名前",
			"enterName": "ワークフロー名を入力",
			"descOptional": "説明（任意）",
			"enterDesc": "ワークフローの説明を入力",
			"saving": "保存中...",
			"update": "更新",
			"cancel": "キャンセル",
			"saveSuccess": "保存しました！",
			"saveFailed": "保存に失敗しました。もう一度お試しください",
			"exportJson": "JSON をエクスポート",
			"exportWorkflow": "ワークフローをエクスポート",
			"exportExecutable": "実行可能ファイルをエクスポート",
			"importJson": "JSON をインポート",
			"importJsonInvalid": "解析できません：JSON が無効か形式が違います。",
			"importJsonNoCanvas": "キャンバスデータがありません（originalFlow、flow、または nodes/edges が必要です）。",
			"importJsonSuccess": "ワークフローを読み込みました（ノード {nodes}、エッジ {edges}）",
			"importJsonReadFailed": "ファイルの読み込みに失敗しました",
			"exportJsonSuccess": "ダウンロードを開始しました",
			"exportJsonFailed": "エクスポートに失敗しました"
		},
		"nodes": {
			"base": {
				"moreActions": "その他のオプション",
				"execute": "実行",
				"cancelExecution": "実行をキャンセル",
				"removeComment": "コメントを削除",
				"commentPlaceholder": "ユーザー向けのコメントを追加...",
				"clickToAddComment": "クリックしてコメントを追加...",
				"addComment": "コメントを追加",
				"delete": "削除",
				"deleteConfirmTitle": "削除の確認",
				"deleteConfirmDescription": "このノードには {count} 個の下流ノードがあります。削除方法を選択してください。",
				"deleteNodeOnly": "このノードのみ削除",
				"deleteNodeAndChildren": "このノードとすべての下流ノードを削除（{count}個）",
				"deleteChildrenOnly": "下流ノードのみ削除（{count}個）",
				"run": "実行",
				"preview": "プレビュー",
				"lock": "ノードをロック",
				"unlock": "ノードのロックを解除",
				"startCombo": "コンボを開始",
				"addToCombo": "コンボに追加",
				"removeFromCombo": "コンボから削除",
				"edit": "編集",
				"cancel": "キャンセル",
				"confirm": "確認",
				"fullscreenEdit": "フルスクリーン編集",
				"startVoice": "音声入力を開始",
				"stopVoice": "音声入力を停止",
				"editText": "テキストを編集",
				"select": "選択",
				"selected": "選択済み",
				"modalNotDeployedTitle": "Modal が未デプロイです",
				"modalNotDeployedDescription": "機能「{feature}」には Modal App「{app}」が必要です。まだデプロイされていません。今すぐデプロイしますか？",
				"modalDeployHint": "1) MODAL_TOKEN_ID / MODAL_TOKEN_SECRET を設定。2) plugins/ があることを確認する。サーバーがプラグイン注釈をメモリ上でスキャンして登録情報を作成します。3) 本機で `python -m modal` が動くことを確認（例: pip install modal）。ワンクリックデプロイはその登録情報に沿って各プラグインの deploy.py に modal deploy をかける。",
				"modalDeployDismiss": "キャンセル",
				"modalDeployAction": "ダウンロード＆デプロイ",
				"modalDeploying": "Modal workers をデプロイ中…",
				"modalDeployDone": "デプロイ完了",
				"modalDeployError": "デプロイ失敗",
				"modalDeployingAction": "デプロイ中…",
				"modalDeployProgressHint": "{done}/{total} をデプロイ済み",
				"pluginImplementationTitle": "実装",
				"pluginModelTitle": "モデル",
				"pluginParamsTitle": "詳細設定",
				"pluginParamsReset": "リセット",
				"pluginParamDefault": "既定 {value}",
				"pluginImplementationLoading": "プラグイン実装一覧を読み込み中…",
				"pluginImplementationEmpty": "この機能向けのプラグイン実装がスキャン結果にありません。リポジトリの plugins/ に Modal または API プラグインを追加してください（README 参照）。ページを再読み込みしてください。",
				"pluginRegistryLoadError": "プラグイン登録情報を読み込めませんでした：{message}",
				"pluginSelectPlaceholder": "リポジトリを選択…",
				"missingImplTitle": "実装が未選択",
				"missingImplDescription": "このノードに利用可能なプラグインがインストールされていません（または未選択です）。実行前に、プラグインマネージャーからインストールするか、インストール済みのプラグインを選択してください。"
			},
			"common": {
				"enterInstructions": "指示を入力してください...",
				"manualInput": "入力",
				"library": "ライブラリ",
				"addText": "テキストを追加",
				"enterText": "テキスト内容を入力...",
				"descOptional": "説明（任意）",
				"fromUpstreamText": "上流テキストノードから",
				"videoDesc": "動画の説明",
				"aspectRatio": "アスペクト比",
				"resolution": "解像度",
				"duration": "長さ",
				"currentSize": "現在のサイズ：",
				"currentDuration": "現在の長さ：",
				"upscaleTierLabel": "拡大モード（長辺）",
				"upscaleTierHint": "縦横比は入力に合わせ、長辺のみをスケールします。",
				"upscaleTier1k": "1K · ~1920",
				"upscaleTier2k": "2K · ~2560",
				"upscaleTier4k": "4K · ~3840",
				"seconds": "秒",
				"minute": "分",
				"thinkingProcess": "思考プロセス",
				"performanceMode": "パフォーマンスモード",
				"ecoMode": "💰 エコモード",
				"proMode": "⚡ プロモード",
				"modelSelect": "モデル",
				"models": {
					"imageEdit": "FLUX2 Klein 画像編集",
					"imageGen": "Z-Image テキスト生成画像",
					"imageFusion": "FLUX2 Klein 画像融合",
					"imageGenVideo": "LTX2 画像から動画",
					"features": {
						"gen-text": "デフォルト（OpenRouter）",
						"gen-text-gemini": "Gemini",
						"gen-text-openai": "OpenAI",
						"split-text": "スマート分割",
						"combine-text": "テキスト結合",
						"combine-text-openai": "テキスト結合（OpenAI）",
						"combine-text-gemini": "テキスト結合（Gemini）",
						"image-fusion": "FLUX2 Klein 融合",
						"image-gen-text": "画像キャプション",
						"video-gen-text": "動画キャプション",
						"transcribe": "音声認識",
						"transcribe-timestamp": "音声認識（タイムスタンプ）",
						"concat-videos": "動画連結",
						"extract-audio": "音声抽出",
						"remove-video-audio": "音声除去（無音動画）",
						"merge-video-audio": "動画+音声合成",
						"get-first-frame": "先頭フレーム",
						"get-last-frame": "末尾フレーム",
						"parse-document": "文書解析",
						"split-video": "シーン分割",
						"link": "URL取得",
						"gen-video": "テキストから動画",
						"image-gen": "Z-Image 文生図",
						"gen-music": "ACE-Step 音楽",
						"text-gen-speech-preset": "音声合成（プリセット）",
						"image-gen-video": "画像から動画",
						"image-edit": "FLUX2 Klein 編集",
						"image-upscale": "画像アップスケール",
						"video-upscale": "動画アップスケール",
						"image-describe": "画像理解",
						"video-describe": "動画理解",
						"audio-describe": "音声理解",
						"music-repaint": "音楽リペイント",
						"music-cover": "音楽カバー",
						"music-extract": "ステム抽出",
						"music-lego": "トラック追加",
						"music-complete": "編曲補完",
						"music-brief": "音楽ブリーフ",
						"audio-image-gen-video": "音声+画像から動画",
						"speech-text-gen-video": "音声+テキストから動画",
						"video-image-gen-video-mix": "動画+画像ミックス",
						"video-image-gen-video-move": "動画+画像モーション",
						"image-image-gen-video": "画像+画像から動画",
						"text-gen-video": "テキストから動画",
						"image-gen-model": "画像から3D",
						"speech-video-gen-video": "動画+台詞吹き替え",
						"audio-video-lip-sync": "音声+動画リップシンク",
						"text-gen-speech-clone": "ボイスクローン",
						"text-gen-speech-instruct": "指示TTS",
						"video-image-move-animal": "動画+画像（動物）",
						"video-image-move": "動画+画像（人物）",
						"video-image-move-muti": "動画+画像（マルチ）",
						"video-image-move-animal-muti": "動画+画像（動物・マルチ）",
						"wan-animate-mix": "WAN アニメート",
						"subtitle-remove": "字幕除去",
						"remove-watermark": "透かし除去",
						"denoise-audio": "ノイズ除去",
						"separate-audio-track": "ボーカル/伴奏",
						"separate-speaker": "話者分離",
						"convert-voice": "声色変換",
						"drop-video": "クリップ抽出",
						"arrange-group": "バッチ配置"
					}
				},
				"voice": "音声",
				"selectVoice": "音声を選択",
				"previewVoice": "音声をプレビュー",
				"uploadVoice": "音声をアップロード",
				"recordVoice": "音声を録音",
				"voiceClone": "音声クローン",
				"voicePreset": "プリセットスタイル",
				"voiceDescribe": "カスタム説明",
				"gender": "性别",
				"selectGender": "性别を選択（任意）",
				"emotion": "感情",
				"style": "スタイル",
				"selectEmotion": "感情を選択（任意）",
				"selectStyle": "スタイルを選択（任意）",
				"voiceDescription": "音声の説明",
				"voiceDescriptionPlaceholder": "音声スタイルの説明を入力してください。例：優しく甘い女性の声、ゆっくり話す...",
				"referenceAudio": "参照音声",
				"noReferenceAudio": "参照音声をアップロードまたは録音してください（3秒以上）",
				"referenceText": "参照テキスト",
				"referenceTextPlaceholder": "任意：参照音声の書き起こしテキスト。クローン品質の向上に役立ちます",
				"referenceTextCloneHint": "空欄の場合は x-vector クローン。転写テキストを入力すると ICL 高品質クローンになります",
				"language": "言語",
				"inputText": "テキスト入力"
			},
			"titles": {
				"imageGenVideo": "画像から動画",
				"textGenVideo": "テキストから動画",
				"addText": "テキストを追加",
				"textGenText": "テキスト生成",
				"combineText": "テキスト結合",
				"textGenImage": "テキストから画像",
				"textGenSpeechClone": "音声生成（クローン）",
				"textGenSpeechCloneCompose": "ボイスクローン（テキスト+参考音声）",
				"imageGenVideoCompose": "画像から動画（テキスト+画像）",
				"textGenSpeechPreset": "音声生成（プリセット）",
				"textGenSpeechInstruct": "音声生成（説明）",
				"imageFusion": "画像合成",
				"videoUpscale": "動画高画質化",
				"videoGenText": "動画説明",
				"speechRecognize": "音声認識",
				"textGenMusic": "テキストから音楽",
				"speechGenVideo": "音声から動画",
				"convertVoice": "音声変換",
				"denoiseAudio": "音声ノイズ除去",
				"fileGenText": "ドキュメント解析",
				"linkGenText": "リンク抽出",
				"removeSubtitle": "字幕削除",
				"removeWatermark": "透かし削除",
				"separateAudio": "映像・音声の分離",
				"imageGenText": "画像説明",
				"audioDescribe": "音声理解",
				"imageGenImage": "画像編集",
				"videoEdit": "動画編集",
				"imageGenModel": "画像から3Dモデル",
				"imagePose": "ポーズ検出",
				"imageBodySeg": "身体部位セグメンテーション",
				"imageNormal": "表面法線",
				"imageMatting": "人物マッティング",
				"videoGenModel": "ビデオモーションキャプチャ",
				"imageUpscale": "HD高画質化",
				"separateTrack": "ボーカル抽出",
				"separateSpeaker": "話者分離",
				"separateSound": "音の分離",
				"speechImageGenVideo": "音声+画像から動画",
				"concatVideo": "動画結合",
				"mergeVideoAudio": "動画と音声を結合",
				"audioVideoLipSync": "動画リップシンク",
				"speechTextGenVideo": "音声+テキストから動画",
				"speechVideoGenVideo": "動画吹き替え・口パク",
				"imageImageGenVideo": "始点/終点フレーム動画",
				"imagesGenVideo": "複数画像から動画",
				"refsGenVideo": "マルチ参照から動画",
				"textAudioGenSpeech": "テキスト+音声から音声",
				"videoImageMix": "動画+画像ミックス",
				"videoImageMove": "動画+画像移動",
				"splitVideo": "動画分割",
				"splitText": "スマート分割",
				"getFirstFrame": "最初のフレーム",
				"getLastFrame": "最後のフレーム",
				"extractAudioTrack": "音声抽出",
				"removeVideoAudio": "音声除去（無音動画）",
				"musicRepaint": "音楽リペイント",
				"musicCover": "音楽カバー",
				"musicExtract": "ステム抽出",
				"musicLego": "トラック追加",
				"musicComplete": "編曲補完",
				"musicBrief": "音楽ブリーフ",
				"textGenAudio": "テキストからオーディオ"
			},
			"options": {
				"portrait": "縦向き",
				"landscape": "横向き",
				"square": "正方形",
				"standard": "標準",
				"verticalStandard": "縦向き標準",
				"human": "人物",
				"animal": "動物",
				"single": "一人",
				"multi": "複数人"
			},
			"actions": {
				"generateVideo": "動画を生成",
				"generateImage": "画像を生成",
				"generateSpeech": "音声を生成",
				"startFusion": "合成を開始",
				"convertText": "テキストに変換",
				"startUpscale": "高画質化を開始",
				"describeVideo": "動画を説明",
				"recognizeSpeech": "音声を認識",
				"generateMusic": "音楽を生成",
				"generateAudio": "オーディオを生成",
				"startReplace": "置換を開始",
				"startDenoise": "ノイズ除去を開始",
				"parseDocument": "ドキュメントを解析",
				"extractContent": "コンテンツを抽出",
				"removeSubtitle": "字幕を削除",
				"removeWatermark": "透かしを削除",
				"compressVideo": "動画を圧縮",
				"extractAudio": "分離を開始",
				"describeImage": "画像を説明",
				"describeAudio": "音声を説明",
				"editImage": "画像を編集",
				"editVideo": "動画を編集",
				"generate3DModel": "3Dモデルを生成",
				"detectPose": "ポーズを検出",
				"segmentBody": "身体部位を分割",
				"estimateNormal": "法線を推定",
				"extractForeground": "前景を抽出",
				"captureMotion": "モーションをキャプチャ",
				"imageUpscale": "HD高画質化",
				"extractVocals": "ボーカルを抽出",
				"startSeparation": "分離を開始",
				"concatVideo": "動画を結合",
				"startMerge": "結合を開始",
				"lipDub": "吹き替え・口パク",
				"motionTrackGenerate": "軌跡で生成",
				"splitVideo": "動画を分割",
				"splitText": "スマート分割",
				"getFirstFrame": "最初のフレームを取得",
				"getLastFrame": "最後のフレームを取得",
				"extractAudioTrack": "音声を抽出",
				"removeVideoAudio": "音声を除去",
				"repaintMusic": "リペイント開始",
				"coverMusic": "カバー生成",
				"extractStem": "抽出開始",
				"separateSound": "分離開始",
				"addTrack": "トラック生成",
				"completeMusic": "補完開始",
				"musicBrief": "ブリーフ生成"
			},
			"params": {
				"prompt": "プロンプト",
				"model": "モデル",
				"modelDefault": "デフォルト (OpenRouter 無料ルーター)",
				"geminiModel": "Gemini モデル",
				"openaiModel": "OpenAI モデル",
				"style": "スタイル",
				"sampler": "サンプラー",
				"seed": "シード",
				"steps": "ステップ",
				"cfg": "CFGスケール"
			},
			"emotions": {
				"none": "なし",
				"happy": "嬉しい",
				"angry": "怒り",
				"sad": "悲しい",
				"fear": "恐怖",
				"surprised": "驚き",
				"confusion": "困惑",
				"empathy": "共感",
				"embarrass": "恥ずかしい",
				"excited": "興奮",
				"depressed": "落ち込み",
				"admiration": "感嘆",
				"coldness": "冷淡"
			},
			"genders": {
				"none": "なし",
				"male": "男性",
				"female": "女性"
			},
			"styles": {
				"none": "なし",
				"serious": "真剣",
				"arrogant": "傲慢",
				"child": "子供",
				"older": "年配",
				"girl": "少女",
				"pure": "純粋",
				"sister": "お姉さん",
				"sweet": "甘い",
				"exaggerated": "オーバー",
				"ethereal": "幻想的",
				"whisper": "囁き",
				"generous": "寛大",
				"recite": "朗読",
				"act_coy": "甘え",
				"warm": "温かい",
				"shy": "恥ずかしがり",
				"comfort": "癒し",
				"authority": "権威",
				"chat": "雑談",
				"radio": "ラジオ",
				"soulful": "ソウルフル",
				"gentle": "優しい",
				"story": "物語",
				"vivid": "生き生き",
				"program": "司会",
				"news": "ニュース",
				"advertising": "広告",
				"roar": "咆哮",
				"murmur": "つぶやき",
				"shout": "叫び",
				"deeply": "深い",
				"loudly": "大声"
			},
			"recorder": {
				"title": "音声を録音",
				"desc": "音声合成の参照用にオーディオクリップを録音",
				"start": "録音開始",
				"stop": "録音停止",
				"preview": "プレビュー",
				"retry": "やり直し",
				"uploading": "アップロード中...",
				"confirm": "確認",
				"cancel": "キャンセル",
				"recording": "録音中...",
				"recorded": "録音完了",
				"micError": "マイクにアクセスできません。権限を確認してください",
				"uploadError": "アップロードに失敗しました。もう一度お試しください",
				"uploadFailed": "アップロード失敗"
			},
			"imageFusion": {
				"loading": "読み込み中...",
				"imageReference": "画像参照",
				"imageReferenceHint": "画像をクリックしてプロンプトに参照を挿入",
				"fusionPrompt": "合成プロンプト",
				"fusionPromptPlaceholder": "合成の指示を入力してください。例：画像1のスタイルを維持、すべての画像の特徴を合成、画像2の色を強調、画像3の構図を組み合わせ...",
				"imageLabel": "画像"
			},
			"refsGenVideo": {
				"videoReference": "動画参照",
				"videoLabel": "動画",
				"audioReference": "音声参照",
				"audioLabel": "音声",
				"referenceHint": "画像は最大9枚、動画3本、音声3本（合計12ファイル）。音声は画像か動画と組み合わせてください。サムネイルをクリックするとプロンプトに参照を挿入できます。",
				"promptPlaceholder": "生成したい動画を記述してください。例：画像1のキャラクターが音声1の声で話し、動画1のシーンを引き継ぐ…"
			},
			"video": { "fileCount": "処理するファイル：" },
			"speechRecognize": { "withTimestamp": "タイムスタンプ付き" },
			"music": {
				"handleStyle": "スタイル",
				"handleLyric": "歌詞",
				"referenceAudio": "参照音声",
				"inputLyrics": "歌詞を入力",
				"fromUpstreamReadonly": "上流から（読み取り専用）",
				"lyricsPlaceholder": "歌詞入力未接続時に入力",
				"audioDuration": "音声の長さ",
				"currentDuration": "現在の長さ：",
				"seconds": "秒",
				"15s": "15秒",
				"30s": "30秒",
				"1min": "1分",
				"2min": "2分",
				"language": "言語",
				"keyscale": "キー",
				"bpm": "BPM",
				"auto": "自動"
			},
			"musicTasks": {
				"promptLabel": "キャプション",
				"promptPlaceholder": "音楽のスタイル、雰囲気、楽器などを記述...",
				"lyricsLabel": "歌詞",
				"lyricsPlaceholder": "歌詞（任意）...",
				"startTime": "開始（秒）",
				"endTime": "終了（秒）",
				"strength": "強度",
				"track": "トラック",
				"tracks": "追加するトラック",
				"instrumental": "インストゥルメンタル",
				"ideaPlaceholder": "作りたい曲を一文で記述...",
				"sourceAudio": "元の曲",
				"refAudio": "リファレンス音声",
				"trackOptions": {
					"vocals": "ボーカル",
					"backing_vocals": "コーラス",
					"drums": "ドラム",
					"percussion": "パーカッション",
					"bass": "ベース",
					"guitar": "ギター",
					"keyboard": "キーボード",
					"synth": "シンセ",
					"strings": "ストリングス",
					"brass": "ブラス",
					"woodwinds": "木管楽器",
					"fx": "効果音"
				}
			},
			"speechGenVideo": {
				"loading": "読み込み中...",
				"inputContent": "入力内容",
				"audio": "音声",
				"connectAudioHint": "音声ノードを接続するか、音声ファイルをアップロードしてください",
				"audioPromptLabel": "音声プロンプト",
				"audioPromptPlaceholder": "音声吹き替えのプロンプトを入力"
			},
			"convertVoice": {
				"sourceAudio": "元の音声",
				"referenceVoice": "参考ボイス",
				"connectHint": "変換したい音声と、参考にする声の音声をつないでください"
			},
			"removeWatermark": { "hint": "Sora動画の透かしを自動検出して削除" },
			"videoGenText": {
				"promptLabel": "カスタムプロンプト",
				"promptPlaceholder": "デフォルトのプロンプトを使用する場合は空白のままにするか、カスタム指示を入力してください。例：動画の会話内容のみを説明..."
			},
			"imageGenText": {
				"promptLabel": "カスタムプロンプト",
				"promptPlaceholder": "デフォルトを使う場合は空白のまま。例：被写体・雰囲気・画像内の文字のみを説明..."
			},
			"audioDescribe": {
				"promptLabel": "カスタムプロンプト",
				"promptPlaceholder": "空欄でデフォルトプロンプトを使用。ジャンル・雰囲気・楽器・ボーカルの説明など、カスタム指示も入力可能…"
			},
			"textGenText": { "instructions": "指示" },
			"lipDub": {
				"targetDialogue": "目標台詞（プロンプト）",
				"targetDialoguePlaceholder": "キャラクター説明と目標言語の台詞を含む完全なプロンプト（自動翻訳なし）",
				"promptHint": "解像度は参照動画に合わせます。キャラクター＋目標言語の台詞を含む完全なプロンプト（自動翻訳なし）。長さは原動画に近づけ、話者1人のみ。"
			},
			"motionTrack": {
				"connectHint": "先頭フレーム画像、参考動画（動きを自動抽出して転写）、テキストプロンプト（見た目・スタイルのみ）を接続してください。",
				"controlVideo": "参考動画",
				"promptPlaceholder": "見た目とスタイルを記述。動きは参考動画から自動抽出されます。",
				"promptHint": "プロンプトは見た目・スタイルのみ。動きは参考動画から自動抽出されます。長さスライダーは参考動画の上限です。",
				"missing": "あと必要: {items}"
			},
			"lipSync": {
				"scenePrompt": "シーン説明（任意）",
				"scenePromptPlaceholder": "画面と話者を記述。口パクは接続した音声に同期します。台詞全文はここに書かないでください。",
				"audioDrivenHint": "口パクと音声は音声入力に従います。音声の長さは参照動画に近づけてください。出力は既定 720p。"
			},
			"imageEdit": {
				"performanceMode": "パフォーマンスモード",
				"ecoMode": "💰 エコ（FLUX.2 Klein 9B）",
				"proMode": "⚡ プロモード",
				"editInstruction": "編集指示",
				"fromUpstream": "（上流ノードから）",
				"editPlaceholder": "画像編集の指示を入力してください。例：コントラストを上げる、色温度を暖色に調整、ディテールを強調"
			},
			"videoEdit": {
				"editInstruction": "編集指示",
				"fromUpstream": "（上流ノードから）",
				"editPlaceholder": "動画編集の指示を入力してください。例：字幕を除去、水彩風スタイルを適用、空を夕焼けに変更",
				"connectTextVideo": "テキストノードと動画ノードを接続してください"
			},
			"compose": {
				"loading": "読み込み中...",
				"mediaFiles": "メディアファイル",
				"image": "画像",
				"audio": "音声",
				"video": "動画",
				"text": "テキスト",
				"noText": "テキストなし",
				"inputContent": "入力内容",
				"videoFiles": "動画ファイル",
				"connectImageAudio": "画像と音声ファイルを接続してください",
				"connectVideo": "少なくとも1つの動画ファイルを接続してください",
				"connectImageVideoAudio": "画像、動画、音声ファイルを接続してください",
				"connectTextAudio": "テキスト内容と音声ファイルを接続してください",
				"connectTextReferenceAudio": "テキストノードと音声ノード（参考音声）を接続してください",
				"connectTextImage": "テキストノードと画像ノードを接続してください",
				"connectTextVideoNode": "動画ノードとテキストノードを接続してください（目標台詞はプロンプトに記載）",
				"referenceAudio": "参考音声",
				"referenceTextOptional": "参照テキスト（任意・クローン品質向上）",
				"connectVideoAudio": "動画と音声ファイルを接続してください",
				"generatePromptLabel": "生成プロンプト",
				"generatePromptPlaceholder": "動画生成プロンプトを入力：内容、スタイル、アクションなどを説明（任意）",
				"inputText": "テキスト入力",
				"inputTextPlaceholder": "テキスト内容を入力",
				"describeVideo": "生成したい動画を説明...",
				"firstFrame": "最初のフレーム",
				"lastFrame": "最後のフレーム",
				"connectTwoImages": "2つの画像を接続してください（最初と最後のフレーム）",
				"inputData": "入力データ",
				"connectTextAudioNode": "テキストと音声ノードを接続してください",
				"emotion": "感情：",
				"style": "スタイル：",
				"selectEmotion": "感情スタイルを選択（任意）",
				"selectStyle": "音声スタイルを選択（任意）",
				"lipSync": "リップシンク",
				"connectImageVideo": "画像と動画ファイルを接続してください",
				"startSlice": "スライス開始"
			},
			"modal": {
				"audioPreview": "音声プレビュー",
				"audio": "音声",
				"audios": "音声（{count}）",
				"loading": "読み込み中...",
				"unavailable": "コンテンツを読み込めません",
				"more": "もっと見る",
				"moreOptions": "その他のオプション",
				"actions": "アクション",
				"textPreview": "テキストプレビュー",
				"text": "テキスト",
				"texts": "テキスト（{count}）",
				"imagePreview": "画像プレビュー",
				"image": "画像",
				"images": "画像（{count}）",
				"videoPreview": "動画プレビュー",
				"video": "動画",
				"videos": "動画（{count}）",
				"file": "ファイル",
				"files": "ファイル（{count}）",
				"link": "リンク",
				"links": "リンク（{count}）",
				"fullScreenPreview": "フルスクリーンプレビュー",
				"fullScreenWaterfall": "フルスクリーンウォーターフォールプレビュー",
				"model3DPreview": "3Dモデルプレビュー",
				"model3D": "3Dモデル",
				"models3D": "3Dモデル（{count}）",
				"resetView": "ビューをリセット",
				"playAnimation": "アニメーションを再生",
				"pauseAnimation": "アニメーションを一時停止",
				"downloadModel": "モデルをダウンロード",
				"loading3DModel": "3Dモデルを読み込み中...",
				"errorLoadingModel": "モデルの読み込みエラー",
				"dragToRotate": "左クリック+ドラッグで回転 | スクロールでズーム | リセットでセンタリング",
				"noModelLoaded": "3Dモデルが読み込まれていません",
				"loadingPreview": "プレビューを読み込み中...",
				"unsupportedFormat": "サポートされていない形式",
				"supportedFormats": "サポート形式",
				"download": "ダウンロード",
				"textEditor": "テキストエディター",
				"enterText": "テキストを入力してください..."
			},
			"add": {
				"addAudio": "音声を追加",
				"addImage": "画像を追加",
				"addVideo": "動画を追加",
				"addText": "テキストを追加",
				"addFile": "ファイルを追加",
				"addModel": "3Dモデルを追加",
				"addLink": "リンクを追加",
				"record": "録音",
				"recordVideo": "録画",
				"upload": "アップロード",
				"library": "ライブラリ",
				"recorded": "録音済み",
				"uploading": "アップロード中",
				"confirmAndUpload": "確認してアップロード",
				"dropToUpload": "ファイルをドロップしてアップロード",
				"dragOrClick": "ファイルをここにドラッグするか、クリックしてアップロード",
				"supportedAudioFormats": "MP3、WAV、OGG、M4Aをサポート",
				"supportedImageFormats": "一般的な画像形式をサポート",
				"supportedVideoFormats": "MP4、MOV、WEBMをサポート",
				"browseFiles": "ファイルを参照",
				"canvas": "キャンバス",
				"camera": "カメラ",
				"openCanvas": "キャンバスを開く",
				"canvasDrawing": "キャンバス描画",
				"canvasDrawingHint": "下のキャンバスに描画してから、完了をクリックして保存",
				"clearCanvas": "キャンバスをクリア",
				"finishAndSave": "完了して保存",
				"clickToStartCamera": "クリックしてカメラを起動",
				"takePhoto": "写真を撮る",
				"closeCamera": "カメラを閉じる",
				"cameraError": "カメラにアクセスできません",
				"cameraErrorHint": "確認してください：1. HTTPSまたはlocalhostを使用 2. カメラの権限を許可 3. カメラが他のアプリで使用されていない",
				"inputText": "テキスト入力",
				"textPlaceholder": "テキスト内容を入力してください...",
				"generate": "確認",
				"linkPlaceholder": "リンクを入力してください",
				"extractContent": "コンテンツを抽出",
				"cancel": "キャンセル",
				"startRecordingVideo": "動画録画を開始",
				"addDocument": "ドキュメントを追加",
				"supportedDocFormats": "複数のドキュメント形式をサポート",
				"dragModel": "3Dモデルファイルをここにドラッグするか、クリックしてアップロード",
				"supportedModelFormats": "サポート形式",
				"modelHint": "ヒント：以下の3Dファイル形式をサポート："
			},
			"batch": {
				"arrangeGroup": "グループを配置",
				"startArrange": "配置を開始",
				"describeRequirements": "要件を説明...",
				"groupCount": "グループ数",
				"allowDuplicate": "重複を許可",
				"videoFilter": "動画フィルター",
				"startFilter": "フィルターを開始"
			},
			"voice": {
				"timbre": "音声：",
				"selectTimbre": "音声を選択",
				"previewTimbre": "現在の音声をプレビュー",
				"uploadTimbre": "音声をアップロード",
				"recordTimbre": "音声を録音",
				"emotion": "感情：",
				"replaceTimbre": "音声を置換"
			},
			"separateSound": {
				"textLabel": "抽出したい音",
				"textPlaceholder": "例:犬の鳴き声、ピアノ、背景のサイレン"
			},
			"textGenAudio": {
				"voiceReference": "参照ボイス",
				"promptLabel": "オーディオの説明",
				"promptPlaceholder": "場面をまるごと書きます：誰がどう話すか、背景の環境音、効果音。セリフは引用符で囲みます。例：@voice1 が言う：「今日はいい天気だね。」窓の外で小雨が降っている。",
				"hint": "話し声・効果音・環境音を一度に生成します。参照ボイスとして音声を最大 3 本つなぎ、クリックすると @voice1…@voice3 が挿入されます。"
			}
		}
	},
	Upload: {
		"failed": "アップロードに失敗しました。後で再試行してください",
		"fileFailed": "ファイル \"{name}\" のアップロードに失敗しました：{reason}",
		"partialFailed": "一部またはすべてのファイルのアップロードに失敗しました",
		"maxFilesExceeded": "最大 {max} 個のファイルまで許可されています",
		"fileTooLarge": "ファイル \"{name}\" が大きすぎます（最大 {max}MB）",
		"fileTypeNotAccepted": "ファイル \"{name}\" の種類はサポートされていません",
		"readImageFailed": "画像情報の読み取りに失敗しました",
		"readVideoFailed": "動画情報の読み取りに失敗しました"
	},
	LibInput: {
		"deleteSuccess": "素材を削除しました",
		"deleteFailed": "削除に失敗しました",
		"emptyText": "空のテキスト",
		"loadFailed": "素材の読み込みに失敗しました",
		"added": "素材を追加しました",
		"retry": "再試行",
		"emptyMaterial": "{type}素材がまだありません",
		"typeImage": "画像",
		"typeVideo": "動画",
		"typeAudio": "音声",
		"typeText": "テキスト",
		"typeFile": "ファイル",
		"typeModel": "モデル",
		"favoriteHint": "ノードの ❤️ アイコンをクリックして素材をお気に入りに追加",
		"portfolio": "ポートフォリオ"
	},
	Recorder: {
		"audioStart": "録音開始",
		"audioCancel": "キャンセル",
		"audioCancelTooltip": "録音をキャンセル",
		"audioFinish": "完了",
		"audioFinishTooltip": "録音を完了",
		"audioPermissionError": "マイクにアクセスできません。権限を許可してください。",
		"videoPermissionError": "カメラとマイクにアクセスできません。権限を許可してください。",
		"videoStart": "録画開始",
		"videoStop": "録画停止"
	},
	Languages: {
		"auto": "自動",
		"zh": "中国語",
		"ja": "日本語",
		"yue": "広東語",
		"en": "英語",
		"ko": "韓国語",
		"fr": "フランス語",
		"es": "スペイン語",
		"de": "ドイツ語",
		"ru": "ロシア語",
		"pt": "ポルトガル語",
		"it": "イタリア語"
	},
	Errors: {
		"somethingWentWrong": "問題が発生しました",
		"tryAgain": "再試行",
		"details": "詳細",
		"copy": "コピー",
		"copied": "コピーしました",
		"close": "閉じる",
		"openModalBilling": "Modal の請求設定を開く",
		"needHelp": "解決しない場合はこちらへ：",
		"wechatGroup": "WeChat グループ",
		"wechatQrAlt": "WeChat グループの QR コード"
	},
	Api: {
		"unknownError": "不明なエラー",
		"unauthorized": "認証されていません",
		"accessDenied": "アクセスが拒否されました",
		"requestFailed": "リクエスト失敗：{status} {statusText}",
		"success": "成功しました",
		"timedOut": "リクエストがタイムアウトしました。再試行してください"
	}
};
//#endregion
//#region src/canvas/i18n/messages/ko.json
var ko_default = {
	Workspace: {
		"edges": {
			"deleteConfirmTitle": "연결을 삭제하시겠습니까?",
			"deleteConfirmDescription": "이 연결은 어떤 노드에도 연결되어 있지 않습니다. 삭제하시겠습니까?",
			"delete": "삭제",
			"cancel": "취소"
		},
		"handles": {
			"text": "텍스트",
			"image": "이미지",
			"image2": "이미지 2",
			"images": "이미지",
			"end_image": "끝 이미지",
			"video": "비디오",
			"videos": "비디오",
			"audio": "오디오",
			"speech": "음성",
			"ref_audio": "참조 오디오",
			"ref_text": "참조 텍스트",
			"document": "문서",
			"byFeature": { "image-image-gen-video": {
				"image": "첫 프레임",
				"end_image": "마지막 프레임"
			} }
		},
		"modeSwitch": {
			"createMode": "생성 모드",
			"executeMode": "실행 모드",
			"appMode": "앱 모드",
			"upgradeRequired": "실행 모드를 사용하려면 업그레이드하세요"
		},
		"appView": {
			"inputsTitle": "입력",
			"outputsTitle": "결과",
			"run": "실행",
			"cancel": "중지",
			"stepProgress": "{current}/{total} 단계",
			"completed": "완료",
			"failed": "실행에 실패했습니다",
			"emptyWorkflow": "캔버스가 비어 있습니다. 먼저 워크플로를 만들어 주세요",
			"invalidWorkflow": "워크플로에 순환 연결이 있어 실행할 수 없습니다",
			"nothingToRun": "이 워크플로에는 실행할 단계가 없습니다",
			"noOutputsYet": "실행하면 결과가 여기에 표시됩니다",
			"dropFilesHere": "파일을 여기에 끌어다 놓거나 클릭해서 업로드",
			"copyText": "복사",
			"download": "다운로드",
			"goToCreateMode": "생성 모드로 이동",
			"textPlaceholder": "여기에 입력…",
			"fieldType": {
				"text": "텍스트",
				"image": "이미지",
				"audio": "오디오",
				"video": "비디오",
				"model": "3D 모델",
				"file": "파일"
			}
		},
		"smartIsland": {
			"category": {
				"digitalHuman": "디지털 휴먼",
				"artDesign": "아트 & 디자인",
				"videoAd": "비디오 & 광고",
				"docProcessing": "문서 처리",
				"knowledgeLearning": "지식 학습",
				"musicMV": "음악/MV"
			},
			"enterWorkflowName": "워크플로 이름 입력",
			"saveSuccess": "저장되었습니다!",
			"saveFailed": "저장에 실패했습니다. 다시 시도해 주세요",
			"generateVideo": "비디오 생성",
			"generateAudio": "오디오 생성",
			"generateText": "텍스트 생성",
			"generateImage": "이미지 생성",
			"generateMusic": "음악 생성",
			"generate3D": "3D 생성",
			"detectPose": "포즈",
			"segmentBody": "신체 분할",
			"estimateNormal": "노멀",
			"extractForeground": "매팅",
			"captureMotion": "모션 캡처",
			"firstLastFrameVideo": "첫/마지막 프레임 비디오",
			"confirmExecute": "실행 확인",
			"deployModalWorkers": "Modal 워커 배포",
			"deployModalRunning": "Modal 워커 배포 중...",
			"deployModalSuccess": "Modal 워커가 배포되었습니다",
			"deployModalFailed": "Modal 배포 실패",
			"deployModalUnsupported": "이 작업은 데스크톱 앱에서만 사용할 수 있습니다",
			"saveAndExecute": "저장 후 실행",
			"cancel": "취소",
			"executeConfirmTitle": "워크플로 실행 확인",
			"executeConfirmDescSaved": "실행 전에 워크플로가 최신 상태로 저장됩니다. 실행하시겠습니까?",
			"executeConfirmDescNew": "실행 전에 워크플로를 저장하세요. 생성된 자료는 향후 참조 및 관리를 위해 이 워크플로와 연결됩니다.",
			"executeWorkflow": "워크플로 실행",
			"saveWorkflow": "워크플로 저장",
			"executing": "실행 중...",
			"saving": "저장 중...",
			"estimatedCost": "예상 비용:",
			"estimatedTime": "예상 시간:",
			"workflowName": "워크플로 이름",
			"workflowNamePlaceholder": "워크플로 이름 입력",
			"workflowDescription": "워크플로 설명",
			"workflowDescPlaceholder": "워크플로 설명 입력(선택 사항)",
			"tooltip3D": "3D",
			"tooltipDocument": "문서",
			"tooltipImage": "이미지",
			"tooltipText": "텍스트",
			"tooltipVideo": "비디오",
			"tooltipAudio": "오디오",
			"tooltipLink": "링크",
			"split": "분할",
			"splitText": "스마트 분할",
			"speechRecognize": "음성 인식",
			"separateAudio": "보컬 분리",
			"separateSpeaker": "화자 분리",
			"separateSound": "소리 추출",
			"speakWithStyle": "감정 음성 생성",
			"denoise": "노이즈 제거",
			"convertVoice": "음성 교체",
			"filter": "필터",
			"arrange": "배치",
			"concat": "연결",
			"describeReverse": "설명",
			"upscale": "고화질 업스케일",
			"removeSubtitle": "자막 제거",
			"removeWatermark": "워터마크 제거",
			"extractAudioTrack": "오디오 트랙 추출",
			"removeVideoAudio": "오디오 제거",
			"slice": "슬라이스",
			"firstFrame": "첫 프레임",
			"lastFrame": "마지막 프레임",
			"editImage": "이미지 편집",
			"editVideo": "비디오 편집",
			"parseDocument": "문서 파싱",
			"extractContent": "콘텐츠 추출",
			"mergeGroup": "그룹 병합",
			"imageFusion": "이미지 융합",
			"imagesGenVideo": "참조 이미지로 비디오 생성",
			"refsGenVideo": "옴니 참조 비디오",
			"rewriteText": "텍스트 재작성",
			"textToSpeech": "텍스트 음성 변환",
			"textToSpeechClone": "음성 생성(복제)",
			"textToSpeechPreset": "음성 생성(프리셋)",
			"textToSpeechInstruct": "음성 생성(설명)",
			"motionControl": "모션 제어",
			"videoTransfer": "비디오 트랜스퍼",
			"characterReplace": "캐릭터 교체",
			"merge": "병합",
			"lipSync": "립싱크",
			"lipDub": "립 더빙",
			"cloneVoice": "음성 복제",
			"speechGenVideo": "오디오로 비디오 생성",
			"repaintMusic": "리페인트",
			"coverMusic": "커버",
			"extractStem": "스템 추출",
			"addTrack": "트랙 추가",
			"completeMusic": "편곡 완성",
			"musicBrief": "음악 브리프"
		},
		"toast": {
			"executing": "실행 중...",
			"completed": "완료됨",
			"cancelled": "취소됨",
			"cancelling": "취소 중...",
			"failed": "실패",
			"nodes": "노드",
			"cancelTask": "작업 취소",
			"totalDuration": "총 소요 시간",
			"taskCompleted": "작업 완료",
			"taskFailed": "작업 실패",
			"taskFailedWithMsg": "작업 실패: {error}",
			"level": "레벨 {level}"
		},
		"dialog": {
			"myWorkflows": "내 워크플로",
			"noWorkflows": "워크플로 없음",
			"savedWorkflowsHint": "저장된 워크플로가 여기에 표시됩니다",
			"noMore": "더 이상 워크플로가 없습니다",
			"loadSuccess": "불러왔습니다!",
			"loadFailed": "불러오기에 실패했습니다. 다시 시도해 주세요",
			"open": "열기"
		},
		"menu": {
			"save": "저장",
			"saveAs": "다른 이름으로 저장",
			"clear": "지우기",
			"confirmClear": "현재 워크플로를 지우시겠습니까? 이 작업은 되돌릴 수 없습니다.",
			"cleared": "워크플로가 지워졌습니다",
			"saveAsNew": "새 워크플로로 저장",
			"saveWorkflow": "워크플로 저장",
			"saveNew": "새로 저장",
			"name": "이름",
			"enterName": "워크플로 이름 입력",
			"descOptional": "설명(선택 사항)",
			"enterDesc": "워크플로 설명 입력",
			"saving": "저장 중...",
			"update": "업데이트",
			"cancel": "취소",
			"saveSuccess": "저장되었습니다!",
			"saveFailed": "저장에 실패했습니다. 다시 시도해 주세요",
			"exportJson": "JSON 내보내기",
			"exportWorkflow": "워크플로 내보내기",
			"exportExecutable": "실행 파일 내보내기",
			"importJson": "JSON 가져오기",
			"importJsonInvalid": "파싱할 수 없습니다: 잘못된 JSON 또는 구조입니다.",
			"importJsonNoCanvas": "이 파일에는 캔버스 데이터가 없습니다(루트에 originalFlow, flow 또는 nodes/edges가 필요합니다).",
			"importJsonSuccess": "워크플로를 불러왔습니다(노드 {nodes}개, 엣지 {edges}개)",
			"importJsonReadFailed": "파일을 읽지 못했습니다",
			"exportJsonSuccess": "다운로드가 시작되었습니다",
			"exportJsonFailed": "내보내기에 실패했습니다. 다시 시도해 주세요"
		},
		"nodes": {
			"base": {
				"moreActions": "추가 옵션",
				"execute": "실행",
				"cancelExecution": "실행 취소",
				"removeComment": "댓글 제거",
				"commentPlaceholder": "사용자를 위한 댓글 추가...",
				"clickToAddComment": "클릭하여 댓글 추가...",
				"addComment": "댓글 추가",
				"delete": "삭제",
				"deleteConfirmTitle": "삭제 확인",
				"deleteConfirmDescription": "이 노드에는 {count}개의 다운스트림 노드가 있습니다. 삭제 방법을 선택하세요.",
				"deleteNodeOnly": "이 노드만 삭제",
				"deleteNodeAndChildren": "이 노드와 모든 다운스트림 노드 삭제({count})",
				"deleteChildrenOnly": "다운스트림 노드만 삭제({count})",
				"run": "실행",
				"preview": "미리보기",
				"lock": "노드 잠금",
				"unlock": "노드 잠금 해제",
				"startCombo": "콤보 시작",
				"addToCombo": "콤보에 추가",
				"removeFromCombo": "콤보에서 제거",
				"edit": "편집",
				"cancel": "취소",
				"confirm": "확인",
				"fullscreenEdit": "전체 화면 편집",
				"startVoice": "음성 입력 시작",
				"stopVoice": "음성 입력 중지",
				"editText": "텍스트 편집",
				"select": "선택",
				"selected": "선택됨",
				"modalNotDeployedTitle": "Modal 앱이 배포되지 않았습니다",
				"modalNotDeployedDescription": "\"{feature}\" 기능에는 Modal 앱 \"{app}\"이(가) 필요합니다. 아직 배포되지 않았습니다. 지금 배포하시겠습니까?",
				"modalDeployHint": "1) MODAL_TOKEN_ID / MODAL_TOKEN_SECRET를 설정합니다. 2) plugins/ 디렉터리가 있는지 확인합니다. 서버는 메모리에서 플러그인 주석을 스캔합니다. 3) `python -m modal`이 작동하는지 확인한 후(예: pip install modal) 원클릭 배포를 사용하여 해당 레지스트리의 각 플러그인 deploy.py에 대해 modal deploy를 실행합니다.",
				"modalDeployDismiss": "취소",
				"modalDeployAction": "다운로드 및 배포",
				"modalDeploying": "Modal 워커 배포 중…",
				"modalDeployDone": "배포가 완료되었습니다",
				"modalDeployError": "배포에 실패했습니다",
				"modalDeployingAction": "배포 중…",
				"modalDeployProgressHint": "{done}/{total} 배포됨",
				"pluginImplementationTitle": "구현",
				"pluginModelTitle": "모델",
				"pluginParamsTitle": "고급 설정",
				"pluginParamsReset": "초기화",
				"pluginParamDefault": "기본 {value}",
				"pluginImplementationLoading": "플러그인 구현을 불러오는 중…",
				"pluginImplementationEmpty": "이 기능에 대해 스캔된 플러그인 구현이 없습니다. 저장소의 plugins/ 디렉터리 아래에 Modal 또는 API 플러그인을 추가한 후(README 참조) 이 페이지를 새로 고치세요.",
				"pluginRegistryLoadError": "플러그인 레지스트리를 불러올 수 없습니다: {message}",
				"pluginSelectPlaceholder": "저장소 선택…",
				"missingImplTitle": "구현 누락",
				"missingImplDescription": "실행하기 전에 이 노드에서 플러그인 구현을 선택하세요."
			},
			"common": {
				"enterInstructions": "지시 사항 입력...",
				"manualInput": "입력",
				"library": "라이브러리",
				"addText": "텍스트 추가",
				"enterText": "텍스트 내용 입력...",
				"descOptional": "설명(선택 사항)",
				"fromUpstreamText": "업스트림 텍스트 노드에서",
				"videoDesc": "비디오 설명",
				"aspectRatio": "종횡비",
				"resolution": "해상도",
				"duration": "길이",
				"currentSize": "현재 크기:",
				"currentDuration": "현재 길이:",
				"upscaleTierLabel": "출력 등급(긴 변)",
				"upscaleTierHint": "종횡비는 입력을 따르며 긴 변만 확대됩니다.",
				"upscaleTier1k": "1K · ~1920",
				"upscaleTier2k": "2K · ~2560",
				"upscaleTier4k": "4K · ~3840",
				"seconds": "초",
				"minute": "분",
				"thinkingProcess": "사고 과정",
				"performanceMode": "성능 모드",
				"ecoMode": "💰 절약 모드",
				"proMode": "⚡ 프로 모드",
				"modelSelect": "모델",
				"models": {
					"imageEdit": "FLUX2 Klein 이미지 편집",
					"imageGen": "Z-Image 텍스트-이미지",
					"imageFusion": "FLUX2 Klein 이미지 융합",
					"imageGenVideo": "LTX2 이미지-비디오",
					"features": {
						"gen-text": "기본값(OpenRouter)",
						"gen-text-gemini": "Gemini",
						"gen-text-openai": "OpenAI",
						"split-text": "스마트 분할",
						"combine-text": "텍스트 병합",
						"combine-text-openai": "텍스트 병합(OpenAI)",
						"combine-text-gemini": "텍스트 병합(Gemini)",
						"image-fusion": "FLUX2 Klein 융합",
						"image-gen-text": "이미지 캡션",
						"video-gen-text": "비디오 캡션",
						"transcribe": "음성-텍스트 변환",
						"transcribe-timestamp": "음성-텍스트 변환(타임스탬프 포함)",
						"concat-videos": "비디오 연결",
						"extract-audio": "오디오 트랙 추출",
						"remove-video-audio": "오디오 제거(무음 비디오)",
						"merge-video-audio": "오디오 + 비디오 합성",
						"get-first-frame": "첫 프레임",
						"get-last-frame": "마지막 프레임",
						"parse-document": "문서-텍스트 변환",
						"split-video": "샷별 분할",
						"link": "URL에서 가져오기",
						"gen-video": "텍스트-비디오",
						"image-gen": "Z-Image 텍스트-이미지",
						"gen-music": "ACE-Step 음악",
						"text-gen-speech-preset": "TTS(프리셋 스타일)",
						"image-gen-video": "이미지-비디오",
						"image-edit": "FLUX2 Klein 편집",
						"image-upscale": "이미지 업스케일",
						"video-upscale": "비디오 업스케일",
						"image-describe": "이미지 이해",
						"video-describe": "비디오 이해",
						"audio-describe": "오디오 이해",
						"music-repaint": "음악 리페인트",
						"music-cover": "음악 커버",
						"music-extract": "스템 추출",
						"music-lego": "트랙 추가",
						"music-complete": "편곡 완성",
						"music-brief": "음악 브리프",
						"audio-image-gen-video": "음성+이미지-비디오",
						"speech-text-gen-video": "음성+텍스트-비디오",
						"video-image-gen-video-mix": "비디오+이미지 믹스",
						"video-image-gen-video-move": "비디오+이미지 무브",
						"image-image-gen-video": "이미지+이미지-비디오",
						"text-gen-video": "텍스트-비디오",
						"image-gen-model": "이미지-3D",
						"speech-video-gen-video": "비디오 립 더빙(텍스트+비디오)",
						"audio-video-lip-sync": "오디오+비디오 립싱크",
						"text-gen-speech-clone": "음성 복제 TTS",
						"text-gen-speech-instruct": "지시형 TTS",
						"video-image-move-animal": "비디오+이미지 무브(동물)",
						"video-image-move": "비디오+이미지 무브(사람)",
						"video-image-move-muti": "비디오+이미지 무브(다중)",
						"video-image-move-animal-muti": "비디오+이미지 무브(동물, 다중)",
						"wan-animate-mix": "WAN 애니메이트 믹스",
						"subtitle-remove": "자막 제거",
						"remove-watermark": "워터마크 제거",
						"denoise-audio": "오디오 노이즈 제거",
						"separate-audio-track": "보컬 / 반주",
						"separate-speaker": "화자 분리",
						"convert-voice": "음성 교체",
						"drop-video": "클립 필터링",
						"arrange-group": "배치 정렬"
					}
				},
				"voice": "음성",
				"selectVoice": "음성 선택",
				"previewVoice": "음성 미리듣기",
				"uploadVoice": "음성 업로드",
				"recordVoice": "음성 녹음",
				"voiceClone": "음성 복제",
				"voicePreset": "프리셋 스타일",
				"voiceDescribe": "사용자 정의 설명",
				"gender": "성별",
				"selectGender": "성별 선택(선택 사항)",
				"emotion": "감정",
				"style": "스타일",
				"selectEmotion": "감정 선택(선택 사항)",
				"selectStyle": "스타일 선택(선택 사항)",
				"voiceDescription": "음성 설명",
				"voiceDescriptionPlaceholder": "음성 스타일 설명을 입력하세요. 예: 부드럽고 달콤한 여성 목소리, 천천히 말하기...",
				"referenceAudio": "참조 오디오",
				"noReferenceAudio": "참조 클립을 업로드하거나 녹음하세요(3초 이상)",
				"referenceText": "참조 텍스트",
				"referenceTextPlaceholder": "선택 사항: 참조 오디오의 전사본 — 복제 품질을 향상시킵니다",
				"referenceTextCloneHint": "빠른 x-vector 복제는 비워 두고, 더 높은 품질의 ICL 복제를 위해서는 참조 전사본을 붙여넣으세요",
				"language": "언어",
				"inputText": "입력 텍스트"
			},
			"titles": {
				"imageGenVideo": "이미지-비디오",
				"textGenVideo": "텍스트-비디오",
				"addText": "텍스트 추가",
				"textGenText": "텍스트 생성",
				"combineText": "텍스트 결합",
				"textGenImage": "텍스트-이미지",
				"textGenSpeechClone": "음성 생성(복제)",
				"textGenSpeechCloneCompose": "음성 복제(텍스트 + 오디오)",
				"imageGenVideoCompose": "이미지-비디오(텍스트 + 이미지)",
				"textGenSpeechPreset": "음성 생성(프리셋)",
				"textGenSpeechInstruct": "음성 생성(설명)",
				"imageFusion": "이미지 융합",
				"videoUpscale": "비디오 업스케일",
				"videoGenText": "비디오 설명",
				"speechRecognize": "음성 인식",
				"textGenMusic": "텍스트-음악",
				"speechGenVideo": "오디오-비디오",
				"convertVoice": "음성 교체",
				"denoiseAudio": "오디오 노이즈 제거",
				"fileGenText": "문서 파서",
				"linkGenText": "링크 추출기",
				"removeSubtitle": "자막 제거",
				"removeWatermark": "워터마크 제거",
				"separateAudio": "오디오 & 비디오 분리",
				"imageGenText": "이미지 설명",
				"audioDescribe": "오디오 이해",
				"imageGenImage": "이미지 편집",
				"videoEdit": "비디오 편집",
				"imageGenModel": "이미지-3D 모델",
				"imagePose": "포즈 감지",
				"imageBodySeg": "신체 부위 분할",
				"imageNormal": "표면 노멀",
				"imageMatting": "인물 매팅",
				"videoGenModel": "비디오 모션 캡처",
				"imageUpscale": "고화질 업스케일",
				"separateTrack": "보컬 추출",
				"separateSpeaker": "화자 분리",
				"separateSound": "소리 분리",
				"speechImageGenVideo": "음성+이미지-비디오",
				"concatVideo": "비디오 연결",
				"mergeVideoAudio": "비디오 오디오 병합",
				"audioVideoLipSync": "비디오 립싱크",
				"speechTextGenVideo": "음성+텍스트-비디오",
				"speechVideoGenVideo": "비디오 립 더빙",
				"imageImageGenVideo": "첫/마지막 프레임 비디오",
				"imagesGenVideo": "이미지-비디오",
				"refsGenVideo": "옴니 참조 비디오",
				"textAudioGenSpeech": "텍스트+오디오-음성",
				"videoImageMix": "비디오+이미지 믹스",
				"videoImageMove": "비디오+이미지 무브",
				"splitVideo": "비디오 분할",
				"splitText": "스마트 분할",
				"getFirstFrame": "첫 프레임",
				"getLastFrame": "마지막 프레임",
				"extractAudioTrack": "오디오 트랙 추출",
				"removeVideoAudio": "오디오 제거(무음 비디오)",
				"musicRepaint": "음악 리페인트",
				"musicCover": "음악 커버",
				"musicExtract": "스템 추출",
				"musicLego": "트랙 추가",
				"musicComplete": "편곡 완성",
				"musicBrief": "음악 브리프",
				"textGenAudio": "텍스트로 오디오 생성"
			},
			"options": {
				"portrait": "세로",
				"landscape": "가로",
				"square": "정사각형",
				"standard": "표준",
				"verticalStandard": "세로 표준",
				"human": "사람",
				"animal": "동물",
				"single": "단일",
				"multi": "다중"
			},
			"actions": {
				"generateVideo": "비디오 생성",
				"generateImage": "이미지 생성",
				"generateSpeech": "음성 생성",
				"startFusion": "융합 시작",
				"convertText": "텍스트로 변환",
				"startUpscale": "업스케일 시작",
				"describeVideo": "비디오 설명",
				"recognizeSpeech": "음성 인식",
				"generateMusic": "음악 생성",
				"generateAudio": "오디오 생성",
				"startReplace": "교체 시작",
				"startDenoise": "노이즈 제거 시작",
				"parseDocument": "문서 파싱",
				"extractContent": "콘텐츠 추출",
				"removeSubtitle": "자막 제거",
				"removeWatermark": "워터마크 제거",
				"compressVideo": "비디오 압축",
				"extractAudio": "분리 시작",
				"describeImage": "이미지 설명",
				"describeAudio": "오디오 설명",
				"editImage": "이미지 편집",
				"editVideo": "비디오 편집",
				"generate3DModel": "3D 모델 생성",
				"detectPose": "포즈 감지",
				"segmentBody": "신체 부위 분할",
				"estimateNormal": "노멀 추정",
				"extractForeground": "전경 추출",
				"captureMotion": "모션 캡처",
				"imageUpscale": "고화질 업스케일",
				"extractVocals": "보컬 추출",
				"startSeparation": "분리 시작",
				"concatVideo": "비디오 연결",
				"startMerge": "병합 시작",
				"lipDub": "립 더빙",
				"motionTrackGenerate": "생성(모션 트랙)",
				"splitVideo": "비디오 분할",
				"splitText": "스마트 분할",
				"getFirstFrame": "첫 프레임 가져오기",
				"getLastFrame": "마지막 프레임 가져오기",
				"extractAudioTrack": "오디오 추출",
				"removeVideoAudio": "오디오 제거",
				"repaintMusic": "리페인트 시작",
				"coverMusic": "커버 생성",
				"extractStem": "분리 시작",
				"separateSound": "분리 시작",
				"addTrack": "트랙 생성",
				"completeMusic": "보완 시작",
				"musicBrief": "브리프 생성"
			},
			"params": {
				"prompt": "프롬프트",
				"model": "모델",
				"modelDefault": "기본값(OpenRouter 무료)",
				"geminiModel": "Gemini 모델",
				"openaiModel": "OpenAI 모델",
				"style": "스타일",
				"sampler": "샘플러",
				"seed": "시드",
				"steps": "스텝",
				"cfg": "CFG 스케일"
			},
			"emotions": {
				"none": "없음",
				"happy": "행복",
				"angry": "분노",
				"sad": "슬픔",
				"fear": "두려움",
				"surprised": "놀람",
				"confusion": "혼란",
				"empathy": "공감",
				"embarrass": "당황",
				"excited": "흥분",
				"depressed": "우울",
				"admiration": "감탄",
				"coldness": "냉담"
			},
			"genders": {
				"none": "없음",
				"male": "남성",
				"female": "여성"
			},
			"styles": {
				"none": "없음",
				"serious": "진지함",
				"arrogant": "거만함",
				"child": "어린이",
				"older": "노년",
				"girl": "소녀",
				"pure": "순수함",
				"sister": "성숙한 여성",
				"sweet": "달콤함",
				"exaggerated": "과장됨",
				"ethereal": "몽환적",
				"whisper": "속삭임",
				"generous": "관대함",
				"recite": "낭독",
				"act_coy": "교태",
				"warm": "따뜻함",
				"shy": "수줍음",
				"comfort": "위로",
				"authority": "권위적",
				"chat": "대화",
				"radio": "라디오",
				"soulful": "감성적",
				"gentle": "부드러움",
				"story": "이야기",
				"vivid": "생생함",
				"program": "진행자",
				"news": "뉴스",
				"advertising": "광고",
				"roar": "포효",
				"murmur": "중얼거림",
				"shout": "외침",
				"deeply": "깊음",
				"loudly": "큰 소리"
			},
			"recorder": {
				"title": "음성 녹음",
				"desc": "음성 합성을 위한 참조로 오디오 클립을 녹음하세요",
				"start": "녹음 시작",
				"stop": "녹음 중지",
				"preview": "미리듣기",
				"retry": "다시 시도",
				"uploading": "업로드 중...",
				"confirm": "확인",
				"cancel": "취소",
				"recording": "녹음 중...",
				"recorded": "녹음 완료",
				"micError": "마이크에 접근할 수 없습니다. 권한을 확인하세요",
				"uploadError": "업로드에 실패했습니다. 다시 시도해 주세요",
				"uploadFailed": "업로드 실패"
			},
			"imageFusion": {
				"loading": "불러오는 중...",
				"imageReference": "이미지 참조",
				"imageReferenceHint": "이미지를 클릭하여 프롬프트에 참조를 삽입하세요",
				"fusionPrompt": "융합 프롬프트",
				"fusionPromptPlaceholder": "융합 지시 사항을 입력하세요. 예: 이미지 1의 스타일 유지, 모든 이미지의 특징 융합, 이미지 2의 색상 강조, 이미지 3의 구도 결합...",
				"imageLabel": "이미지"
			},
			"refsGenVideo": {
				"videoReference": "비디오 참조",
				"videoLabel": "비디오",
				"audioReference": "오디오 참조",
				"audioLabel": "오디오",
				"referenceHint": "이미지 최대 9장, 비디오 3개, 오디오 3개(총 12개 파일). 오디오는 이미지나 비디오와 함께 사용해야 합니다. 썸네일을 클릭하면 프롬프트에 참조가 삽입됩니다.",
				"promptPlaceholder": "생성할 비디오를 설명하세요. 예: 이미지 1의 캐릭터가 오디오 1의 목소리로 말하며 비디오 1의 장면을 이어갑니다..."
			},
			"video": { "fileCount": "처리할 파일:" },
			"speechRecognize": { "withTimestamp": "타임스탬프 포함" },
			"music": {
				"handleStyle": "스타일",
				"handleLyric": "가사",
				"referenceAudio": "참조 오디오",
				"inputLyrics": "가사 입력",
				"audioDuration": "오디오 길이",
				"currentDuration": "현재 길이:",
				"seconds": "초",
				"15s": "15초",
				"30s": "30초",
				"1min": "1분",
				"2min": "2분",
				"styleSettings": "음악 스타일",
				"voiceGender": "음성",
				"genders": {
					"male": "남성",
					"female": "여성"
				},
				"timbre": "음색",
				"timbres": {
					"bright": "밝음",
					"dark": "어두움",
					"warm": "따뜻함",
					"soft": "부드러움",
					"rock": "록",
					"vocal": "보컬"
				},
				"genre": "장르",
				"genres": {
					"pop": "팝",
					"rock": "록",
					"electronic": "일렉트로닉",
					"hiphop": "힙합",
					"jazz": "재즈",
					"blues": "블루스",
					"classical": "클래식",
					"folk": "포크",
					"country": "컨트리",
					"rnb": "R&B",
					"kpop": "K-Pop",
					"reggae": "레게",
					"soul": "소울",
					"dance": "댄스",
					"rap": "랩",
					"classicRock": "클래식 록",
					"hardRock": "하드 록",
					"rockabilly": "로커빌리",
					"dancepop": "댄스 팝",
					"house": "하우스",
					"deephouse": "딥 하우스",
					"experimental": "실험적",
					"experimentalPop": "실험적 팝",
					"popPunk": "팝 펑크",
					"rockAndRoll": "로큰롤",
					"popRock": "팝 록"
				},
				"mood": "분위기",
				"moods": {
					"happy": "행복",
					"sad": "슬픔",
					"romantic": "로맨틱",
					"melancholic": "우울",
					"uplifting": "고양",
					"intense": "강렬함",
					"emotional": "감성적",
					"angry": "분노"
				},
				"instrumentAndRhythm": "악기 & 리듬",
				"instrument": "악기",
				"selectedCount": "{count}개 선택됨",
				"instruments": {
					"piano": "피아노",
					"guitar": "기타",
					"acousticGuitar": "어쿠스틱 기타",
					"electricGuitar": "일렉트릭 기타",
					"drums": "드럼",
					"synthesizer": "신디사이저",
					"violin": "바이올린",
					"saxophone": "색소폰",
					"bass": "베이스",
					"beats": "비트",
					"strings": "현악기",
					"cello": "첼로",
					"trumpet": "트럼펫",
					"harmonica": "하모니카",
					"banjo": "밴조",
					"fiddle": "피들",
					"brass": "금관악기",
					"doubleBass": "더블 베이스"
				},
				"bpm": "BPM",
				"slow": "느림",
				"moderate": "보통",
				"fast": "빠름",
				"songTitle": "곡 제목",
				"songTitlePlaceholder": "곡 제목 입력(선택 사항)",
				"noTagsSelected": "선택된 태그 없음",
				"tagsPlaceholder": "예: 여성, 팝, 밝음, 피아노, 행복, 120bpm",
				"tagsHint": "음악 스타일 태그를 쉼표로 구분하여 입력하세요. 예: 성별, 장르, 음색, 악기, 분위기, BPM",
				"fromUpstreamReadonly": "업스트림에서(읽기 전용)",
				"lyricsPlaceholder": "가사 입력이 연결되지 않은 경우 가사를 입력하세요",
				"language": "언어",
				"keyscale": "키 스케일",
				"auto": "자동"
			},
			"musicTasks": {
				"promptLabel": "캡션",
				"promptPlaceholder": "음악 스타일, 분위기, 악기 등을 설명하세요...",
				"lyricsLabel": "가사",
				"lyricsPlaceholder": "가사(선택)...",
				"startTime": "시작(초)",
				"endTime": "종료(초)",
				"strength": "강도",
				"track": "트랙",
				"tracks": "추가할 트랙",
				"instrumental": "연주곡",
				"ideaPlaceholder": "원하는 곡을 한 문장으로 설명하세요...",
				"sourceAudio": "원곡",
				"refAudio": "참조 오디오",
				"trackOptions": {
					"vocals": "보컬",
					"backing_vocals": "백킹 보컬",
					"drums": "드럼",
					"percussion": "퍼커션",
					"bass": "베이스",
					"guitar": "기타",
					"keyboard": "키보드",
					"synth": "신스",
					"strings": "스트링",
					"brass": "브라스",
					"woodwinds": "목관",
					"fx": "이펙트"
				}
			},
			"speechGenVideo": {
				"loading": "불러오는 중...",
				"inputContent": "입력 내용",
				"audio": "오디오",
				"connectAudioHint": "오디오 노드를 연결하거나 오디오 파일을 업로드하세요",
				"audioPromptLabel": "오디오 프롬프트",
				"audioPromptPlaceholder": "오디오 더빙 프롬프트 입력"
			},
			"convertVoice": {
				"sourceAudio": "원본 오디오",
				"referenceVoice": "참고 목소리",
				"connectHint": "바꿀 오디오와 참고할 목소리 오디오를 연결하세요"
			},
			"removeWatermark": { "hint": "Sora 비디오 워터마크를 자동으로 감지하고 제거합니다" },
			"videoGenText": {
				"promptLabel": "사용자 정의 프롬프트",
				"promptPlaceholder": "기본 프롬프트는 비워 두거나 사용자 정의 지시 사항을 입력하세요. 예: 비디오의 대화만 설명..."
			},
			"imageGenText": {
				"promptLabel": "사용자 정의 프롬프트",
				"promptPlaceholder": "기본 프롬프트는 비워 두거나 사용자 정의 지시 사항을 입력하세요. 예: 주요 피사체, 스타일 또는 이미지 내 텍스트 설명..."
			},
			"audioDescribe": {
				"promptLabel": "커스텀 프롬프트",
				"promptPlaceholder": "비워 두면 기본 프롬프트를 사용합니다. 장르, 분위기, 악기, 보컬 설명 등 커스텀 지시를 입력할 수도 있습니다…"
			},
			"textGenText": { "instructions": "지시 사항" },
			"lipDub": {
				"targetDialogue": "대상 대화(프롬프트)",
				"targetDialoguePlaceholder": "캐릭터 설명과 대상 언어 대사를 포함한 전체 프롬프트(모델은 번역하지 않습니다)",
				"promptHint": "출력 해상도는 참조 비디오를 따릅니다. 전체 프롬프트를 사용하세요(캐릭터 + 대상 언어 대사, 자동 번역 없음). 원본 클립 길이에 맞추고 단일 화자만 지원합니다."
			},
			"lipSync": {
				"scenePrompt": "장면 설명(선택 사항)",
				"scenePromptPlaceholder": "샷과 화자를 설명하세요. 립싱크는 연결된 오디오를 따릅니다 — 여기에 전체 대화를 붙여넣지 마세요.",
				"audioDrivenHint": "입 움직임과 오디오는 오디오 입력에서 가져옵니다. 오디오 길이를 참조 비디오에 가깝게 유지하세요. 기본 출력은 720p입니다."
			},
			"motionTrack": {
				"connectHint": "첫 프레임 이미지, 참조 비디오(모션이 자동으로 추적되어 전송됨), 텍스트 프롬프트(외형/스타일만)를 연결하세요.",
				"controlVideo": "참조 비디오",
				"promptPlaceholder": "외형과 스타일을 설명하세요 — 모션은 참조 비디오에서 추출됩니다.",
				"promptHint": "외형/스타일만 설명하세요. 모션은 참조 비디오에서 자동으로 추출됩니다. 길이 슬라이더는 참조 클립 길이를 제한합니다.",
				"missing": "추가로 필요함: {items}"
			},
			"imageEdit": {
				"performanceMode": "성능 모드",
				"ecoMode": "💰 절약(FLUX.2 Klein 9B)",
				"proMode": "⚡ 프로 모드",
				"editInstruction": "편집 지시 사항",
				"fromUpstream": "(업스트림 노드에서)",
				"editPlaceholder": "이미지 편집 지시 사항을 입력하세요. 예: 대비 증가, 색온도를 따뜻하게 조정, 디테일 강화"
			},
			"videoEdit": {
				"editInstruction": "편집 지시 사항",
				"fromUpstream": "(업스트림 노드에서)",
				"editPlaceholder": "비디오 편집 지시 사항을 입력하세요. 예: 자막 제거, 수채화 스타일 적용, 하늘을 노을로 변경",
				"connectTextVideo": "텍스트 노드와 비디오 노드를 연결하세요"
			},
			"compose": {
				"loading": "불러오는 중...",
				"mediaFiles": "미디어 파일",
				"image": "이미지",
				"audio": "오디오",
				"video": "비디오",
				"text": "텍스트",
				"noText": "텍스트 없음",
				"inputContent": "입력 내용",
				"videoFiles": "비디오 파일",
				"connectImageAudio": "이미지와 오디오 파일을 연결하세요",
				"connectVideo": "비디오 파일을 하나 이상 연결하세요",
				"connectImageVideoAudio": "이미지, 비디오, 오디오 파일을 연결하세요",
				"connectTextAudio": "텍스트 내용과 오디오 파일을 연결하세요",
				"connectTextReferenceAudio": "텍스트 노드와 오디오 노드(참조 음성)를 연결하세요",
				"connectTextImage": "텍스트 노드와 이미지 노드를 연결하세요",
				"connectTextVideoNode": "비디오 노드와 텍스트 노드를 연결하세요(대상 대화는 프롬프트에 입력)",
				"referenceAudio": "참조 오디오",
				"referenceTextOptional": "참조 전사본(선택 사항, 복제 품질 향상)",
				"connectVideoAudio": "비디오와 오디오 파일을 연결하세요",
				"generatePromptLabel": "프롬프트 생성",
				"generatePromptPlaceholder": "내용, 스타일, 동작 등을 설명하는 비디오 생성 프롬프트를 입력하세요(선택 사항)",
				"inputText": "입력 텍스트",
				"inputTextPlaceholder": "텍스트 내용 입력",
				"describeVideo": "생성하려는 비디오를 설명하세요...",
				"firstFrame": "첫 프레임",
				"lastFrame": "마지막 프레임",
				"connectTwoImages": "두 개의 이미지를 연결하세요(첫 프레임과 마지막 프레임)",
				"inputData": "입력 데이터",
				"connectTextAudioNode": "텍스트와 오디오 노드를 연결하세요",
				"emotion": "감정:",
				"style": "스타일:",
				"selectEmotion": "감정 스타일 선택(선택 사항)",
				"selectStyle": "음성 스타일 선택(선택 사항)",
				"lipSync": "립싱크",
				"connectImageVideo": "이미지와 비디오 파일을 연결하세요",
				"startSlice": "슬라이스 시작"
			},
			"modal": {
				"audioPreview": "오디오 미리듣기",
				"audio": "오디오",
				"audios": "오디오 ({count})",
				"loading": "불러오는 중...",
				"unavailable": "콘텐츠를 사용할 수 없습니다",
				"more": "더보기",
				"moreOptions": "추가 옵션",
				"actions": "작업",
				"textPreview": "텍스트 미리보기",
				"text": "텍스트",
				"texts": "텍스트 ({count})",
				"imagePreview": "이미지 미리보기",
				"image": "이미지",
				"images": "이미지 ({count})",
				"videoPreview": "비디오 미리보기",
				"video": "비디오",
				"videos": "비디오 ({count})",
				"file": "파일",
				"files": "파일 ({count})",
				"link": "링크",
				"links": "링크 ({count})",
				"fullScreenPreview": "전체 화면 미리보기",
				"fullScreenWaterfall": "전체 화면 워터폴 미리보기",
				"model3DPreview": "3D 모델 미리보기",
				"model3D": "3D 모델",
				"models3D": "3D 모델 ({count})",
				"resetView": "뷰 재설정",
				"playAnimation": "애니메이션 재생",
				"pauseAnimation": "애니메이션 일시정지",
				"downloadModel": "모델 다운로드",
				"loading3DModel": "3D 모델 불러오는 중...",
				"errorLoadingModel": "모델 불러오기 오류",
				"dragToRotate": "왼쪽 클릭 + 드래그로 회전 | 스크롤로 확대/축소 | 재설정 클릭으로 중앙 정렬",
				"noModelLoaded": "불러온 3D 모델이 없습니다",
				"loadingPreview": "미리보기 불러오는 중...",
				"unsupportedFormat": "지원되지 않는 형식",
				"supportedFormats": "지원됨",
				"download": "다운로드",
				"textEditor": "텍스트 편집기",
				"enterText": "텍스트 내용 입력..."
			},
			"add": {
				"addAudio": "오디오 추가",
				"addImage": "이미지 추가",
				"addVideo": "비디오 추가",
				"addText": "텍스트 추가",
				"addFile": "파일 추가",
				"addModel": "3D 모델 추가",
				"addLink": "링크 추가",
				"record": "녹음",
				"recordVideo": "비디오 녹화",
				"upload": "업로드",
				"library": "라이브러리",
				"recorded": "녹화됨",
				"uploading": "업로드 중",
				"confirmAndUpload": "확인 및 업로드",
				"dropToUpload": "파일을 놓아 업로드",
				"dragOrClick": "여기에 파일을 드래그하거나 클릭하여 업로드",
				"supportedAudioFormats": "MP3, WAV, OGG, M4A 지원",
				"supportedImageFormats": "일반적인 이미지 형식 지원",
				"supportedVideoFormats": "MP4, MOV, WEBM 지원",
				"browseFiles": "파일 찾아보기",
				"canvas": "캔버스",
				"camera": "카메라",
				"openCanvas": "캔버스 열기",
				"canvasDrawing": "캔버스 그리기",
				"canvasDrawingHint": "아래 캔버스에 그린 후 완료를 클릭하여 저장하세요",
				"clearCanvas": "캔버스 지우기",
				"finishAndSave": "완료 및 저장",
				"clickToStartCamera": "클릭하여 카메라 시작",
				"takePhoto": "사진 촬영",
				"closeCamera": "카메라 닫기",
				"cameraError": "카메라에 접근할 수 없습니다",
				"cameraErrorHint": "다음을 확인하세요: 1. HTTPS 또는 localhost 사용 2. 카메라 권한 허용 3. 카메라가 다른 앱에서 사용 중이 아님",
				"inputText": "입력 텍스트",
				"textPlaceholder": "텍스트 내용을 입력하세요...",
				"generate": "확인",
				"linkPlaceholder": "링크를 입력하세요",
				"extractContent": "콘텐츠 추출",
				"cancel": "취소",
				"startRecordingVideo": "비디오 녹화 시작",
				"addDocument": "문서 추가",
				"supportedDocFormats": "다양한 문서 형식 지원",
				"dragModel": "여기에 3D 모델 파일을 드래그하거나 클릭하여 업로드",
				"supportedModelFormats": "지원되는 형식",
				"modelHint": "팁: 다음 3D 파일 형식을 지원합니다:"
			},
			"batch": {
				"arrangeGroup": "그룹 배치",
				"startArrange": "배치 시작",
				"describeRequirements": "요구 사항을 설명하세요...",
				"groupCount": "그룹 수",
				"allowDuplicate": "중복 허용",
				"videoFilter": "비디오 필터",
				"startFilter": "필터 시작"
			},
			"voice": {
				"timbre": "음성:",
				"selectTimbre": "음성 선택",
				"previewTimbre": "현재 음성 미리듣기",
				"uploadTimbre": "음성 업로드",
				"recordTimbre": "음성 녹음",
				"emotion": "감정:",
				"replaceTimbre": "음성 교체"
			},
			"separateSound": {
				"textLabel": "추출할 소리",
				"textPlaceholder": "예: 개 짖는 소리, 피아노, 배경 사이렌"
			},
			"textGenAudio": {
				"voiceReference": "참조 음색",
				"promptLabel": "오디오 설명",
				"promptPlaceholder": "장면 전체를 적어 주세요. 누가 어떻게 말하는지, 배경 소리, 효과음까지. 대사는 따옴표로 묶어요. 예: @voice1이 말한다: \"오늘 날씨 좋다.\" 창밖에 가랑비가 내린다.",
				"hint": "말소리, 효과음, 배경음을 한 번에 만들어요. 참조 음색으로 오디오를 최대 3개까지 연결하고, 누르면 @voice1…@voice3이 설명에 들어가요."
			}
		}
	},
	Upload: {
		"failed": "업로드에 실패했습니다. 나중에 다시 시도해 주세요",
		"fileFailed": "파일 \"{name}\" 업로드에 실패했습니다: {reason}",
		"partialFailed": "일부 또는 모든 파일 업로드에 실패했습니다",
		"maxFilesExceeded": "최대 {max}개의 파일만 허용됩니다",
		"fileTooLarge": "파일 \"{name}\"이(가) 너무 큽니다(최대 {max}MB)",
		"fileTypeNotAccepted": "파일 \"{name}\" 유형이 허용되지 않습니다",
		"readImageFailed": "이미지 정보를 읽지 못했습니다",
		"readVideoFailed": "비디오 정보를 읽지 못했습니다"
	},
	LibInput: {
		"deleteSuccess": "자료가 삭제되었습니다",
		"deleteFailed": "삭제에 실패했습니다",
		"emptyText": "빈 텍스트",
		"loadFailed": "자료를 불러오지 못했습니다",
		"added": "자료가 추가되었습니다",
		"retry": "다시 시도",
		"emptyMaterial": "아직 {type} 자료가 없습니다",
		"typeImage": "이미지",
		"typeVideo": "비디오",
		"typeAudio": "오디오",
		"typeText": "텍스트",
		"typeFile": "파일",
		"typeModel": "모델",
		"favoriteHint": "노드의 ❤️ 아이콘을 클릭하여 자료를 즐겨찾기에 추가하세요",
		"portfolio": "포트폴리오"
	},
	Recorder: {
		"audioStart": "녹음 시작",
		"audioCancel": "취소",
		"audioCancelTooltip": "녹음 취소",
		"audioFinish": "완료",
		"audioFinishTooltip": "녹음 완료",
		"audioPermissionError": "마이크에 접근할 수 없습니다. 권한을 허용해 주세요.",
		"videoPermissionError": "카메라 또는 마이크에 접근할 수 없습니다. 권한을 허용해 주세요.",
		"videoStart": "녹화 시작",
		"videoStop": "녹화 중지"
	},
	Languages: {
		"auto": "자동",
		"zh": "중국어",
		"ja": "일본어",
		"yue": "광둥어",
		"en": "영어",
		"ko": "한국어",
		"fr": "프랑스어",
		"es": "스페인어",
		"de": "독일어",
		"ru": "러시아어",
		"pt": "포르투갈어",
		"it": "이탈리아어"
	},
	Errors: {
		"somethingWentWrong": "문제가 발생했습니다",
		"tryAgain": "다시 시도",
		"details": "세부 정보",
		"copy": "복사",
		"copied": "복사됨",
		"close": "닫기",
		"openModalBilling": "Modal 결제 설정 열기",
		"needHelp": "해결이 안 되면 커뮤니티로 오세요:",
		"wechatGroup": "WeChat 그룹",
		"wechatQrAlt": "WeChat 그룹 QR 코드"
	},
	Api: {
		"unknownError": "알 수 없는 오류",
		"unauthorized": "인증되지 않음",
		"accessDenied": "접근 거부됨",
		"requestFailed": "요청 실패: {status} {statusText}",
		"success": "성공",
		"timedOut": "요청 시간이 초과되었습니다. 다시 시도해 주세요"
	}
};
//#endregion
//#region src/canvas/i18n/messages/zh.json
var zh_default = {
	Workspace: {
		"edges": {
			"deleteConfirmTitle": "删除连线？",
			"deleteConfirmDescription": "这条连线没有连接到任何节点，是否删除它？",
			"delete": "删除",
			"cancel": "取消"
		},
		"handles": {
			"text": "文本",
			"image": "图片",
			"image2": "图片 2",
			"images": "图片",
			"end_image": "尾帧图片",
			"video": "视频",
			"videos": "视频",
			"audio": "音频",
			"speech": "语音",
			"ref_audio": "参考音频",
			"ref_text": "参考文本",
			"document": "文档",
			"byFeature": { "image-image-gen-video": {
				"image": "首帧图片",
				"end_image": "尾帧图片"
			} }
		},
		"modeSwitch": {
			"createMode": "创作模式",
			"executeMode": "执行模式",
			"appMode": "应用模式",
			"upgradeRequired": "升级订阅以解锁执行模式"
		},
		"appView": {
			"inputsTitle": "输入",
			"outputsTitle": "结果",
			"run": "运行",
			"cancel": "停止",
			"stepProgress": "第 {current}/{total} 步",
			"completed": "已完成",
			"failed": "运行失败",
			"emptyWorkflow": "画布还是空的，先去搭一个工作流吧",
			"invalidWorkflow": "工作流存在循环连接，无法运行",
			"nothingToRun": "这个工作流还没有可运行的步骤",
			"noOutputsYet": "运行后结果会显示在这里",
			"dropFilesHere": "拖拽文件到这里，或点击上传",
			"copyText": "复制",
			"download": "下载",
			"goToCreateMode": "去创作模式",
			"textPlaceholder": "在这里输入…",
			"fieldType": {
				"text": "文本",
				"image": "图片",
				"audio": "音频",
				"video": "视频",
				"model": "3D 模型",
				"file": "文件"
			}
		},
		"smartIsland": {
			"category": {
				"digitalHuman": "数字人",
				"artDesign": "艺术设计",
				"videoAd": "影视广告",
				"docProcessing": "文档处理",
				"knowledgeLearning": "知识学习",
				"musicMV": "音乐/MV"
			},
			"enterWorkflowName": "请输入工作流名称",
			"saveSuccess": "保存成功！",
			"saveFailed": "保存失败，请重试",
			"generateVideo": "生成视频",
			"generateAudio": "生成音频",
			"generateText": "生成文本",
			"generateImage": "生成图片",
			"generateMusic": "生成音乐",
			"generate3D": "生成3D",
			"detectPose": "姿态",
			"segmentBody": "人体分割",
			"estimateNormal": "法线",
			"extractForeground": "抠图",
			"captureMotion": "动作捕捉",
			"firstLastFrameVideo": "首尾帧生成视频",
			"confirmExecute": "确认执行",
			"deployModalWorkers": "部署 Modal Worker",
			"deployModalRunning": "正在部署 Modal worker...",
			"deployModalSuccess": "Modal worker 部署完成",
			"deployModalFailed": "Modal 部署失败",
			"deployModalUnsupported": "仅桌面版支持此操作",
			"saveAndExecute": "保存并执行",
			"cancel": "取消",
			"executeConfirmTitle": "确认执行工作流",
			"executeConfirmDescSaved": "执行前会保存当前工作流的最新状态，确认执行吗？",
			"executeConfirmDescNew": "执行前需要先保存工作流。保存后生成的素材将关联到此工作流，方便后续追溯和管理。",
			"executeWorkflow": "执行工作流",
			"saveWorkflow": "保存工作流",
			"executing": "执行中...",
			"saving": "保存中...",
			"estimatedCost": "预估费用：",
			"estimatedTime": "预估用时：",
			"workflowName": "工作流名称",
			"workflowNamePlaceholder": "请输入工作流名称",
			"workflowDescription": "工作流描述",
			"workflowDescPlaceholder": "请输入工作流描述（可选）",
			"tooltip3D": "3D",
			"tooltipDocument": "文档",
			"tooltipImage": "图片",
			"tooltipText": "文本",
			"tooltipVideo": "视频",
			"tooltipAudio": "音频",
			"tooltipLink": "链接",
			"split": "打散",
			"splitText": "智能拆分",
			"speechRecognize": "语音识别",
			"separateAudio": "人声分离",
			"separateSpeaker": "说话人分离",
			"separateSound": "提取声音",
			"speakWithStyle": "按情绪配音",
			"denoise": "降噪",
			"convertVoice": "人声替换",
			"filter": "筛选",
			"arrange": "排列组合",
			"concat": "拼接",
			"describeReverse": "反推描述",
			"upscale": "高清放大",
			"removeSubtitle": "去字幕",
			"removeWatermark": "去水印",
			"extractAudioTrack": "提取音轨",
			"removeVideoAudio": "去除音频",
			"slice": "切片",
			"firstFrame": "首帧截图",
			"lastFrame": "尾帧截图",
			"editImage": "编辑图片",
			"editVideo": "编辑视频",
			"parseDocument": "解析文档",
			"extractContent": "提取内容",
			"mergeGroup": "合为一组",
			"imageFusion": "图片融合",
			"imagesGenVideo": "参考生视频",
			"refsGenVideo": "全参考生视频",
			"rewriteText": "文本改写",
			"textToSpeech": "转换为语音",
			"textToSpeechClone": "生成语音(克隆音色)",
			"textToSpeechPreset": "生成语音(预设音色)",
			"textToSpeechInstruct": "生成语音(描述音色)",
			"motionControl": "动作控制",
			"videoTransfer": "动作迁移",
			"characterReplace": "人物替换",
			"merge": "合并",
			"lipSync": "视频对口型",
			"lipDub": "配音对口型",
			"cloneVoice": "克隆语音",
			"speechGenVideo": "音频生成视频",
			"repaintMusic": "重绘片段",
			"coverMusic": "翻唱改风格",
			"extractStem": "分离音轨",
			"addTrack": "加轨",
			"completeMusic": "补全编曲",
			"musicBrief": "音乐企划"
		},
		"toast": {
			"executing": "执行中...",
			"completed": "执行完成",
			"cancelled": "已取消",
			"cancelling": "取消中...",
			"failed": "执行失败",
			"nodes": "节点",
			"cancelTask": "取消任务",
			"totalDuration": "总耗时",
			"taskCompleted": "任务完成",
			"taskFailed": "任务失败",
			"taskFailedWithMsg": "任务失败：{error}",
			"level": "层级 {level}"
		},
		"dialog": {
			"myWorkflows": "我的工作流",
			"noWorkflows": "暂无工作流",
			"savedWorkflowsHint": "保存的工作流将在这里展示",
			"noMore": "没有更多了",
			"loadSuccess": "加载成功！",
			"loadFailed": "加载失败，请重试",
			"open": "打开"
		},
		"menu": {
			"save": "保存",
			"saveAs": "另存为",
			"clear": "清空",
			"confirmClear": "确定要清空当前工作流吗？此操作无法撤销。",
			"cleared": "已清空工作流",
			"saveAsNew": "另存为新工作流",
			"saveWorkflow": "保存工作流",
			"saveNew": "保存为新工作流",
			"name": "名称",
			"enterName": "输入工作流名称",
			"descOptional": "描述（可选）",
			"enterDesc": "输入工作流描述",
			"saving": "保存中...",
			"update": "更新",
			"cancel": "取消",
			"saveSuccess": "保存成功！",
			"saveFailed": "保存失败，请重试",
			"exportJson": "导出 JSON",
			"exportWorkflow": "导出工作流",
			"exportExecutable": "导出可执行文件",
			"importJson": "导入 JSON",
			"importJsonInvalid": "无法解析：不是有效的 JSON 或结构不正确。",
			"importJsonNoCanvas": "该文件缺少画布数据（需要 originalFlow、flow 或根级 nodes/edges）。",
			"importJsonSuccess": "已载入当前工作流（{nodes} 个节点，{edges} 条连线）",
			"importJsonReadFailed": "读取文件失败",
			"exportJsonSuccess": "已开始下载",
			"exportJsonFailed": "导出失败，请重试"
		},
		"nodes": {
			"base": {
				"moreActions": "更多操作",
				"execute": "执行",
				"cancelExecution": "取消执行",
				"removeComment": "移除注释",
				"commentPlaceholder": "为用户添加注释...",
				"clickToAddComment": "点击添加注释...",
				"addComment": "添加注释",
				"delete": "删除",
				"deleteConfirmTitle": "确认删除",
				"deleteConfirmDescription": "该节点有 {count} 个下游节点，请选择删除方式。",
				"deleteNodeOnly": "仅删除当前节点",
				"deleteNodeAndChildren": "删除当前节点及所有下游节点（{count}个）",
				"deleteChildrenOnly": "仅删除所有下游节点（{count}个）",
				"run": "运行",
				"preview": "预览",
				"lock": "锁定节点",
				"unlock": "解锁节点",
				"startCombo": "开始组合",
				"addToCombo": "添加到组合",
				"removeFromCombo": "移出组合",
				"edit": "编辑",
				"cancel": "取消",
				"confirm": "确定",
				"fullscreenEdit": "全屏编辑",
				"startVoice": "开始语音输入",
				"stopVoice": "停止语音输入",
				"editText": "编辑文本",
				"select": "选择",
				"selected": "已选",
				"modalNotDeployedTitle": "未检测到 Modal 部署",
				"modalNotDeployedDescription": "功能「{feature}」需要 Modal App「{app}」。当前未检测到对应部署，是否现在下载/部署？",
				"modalDeployHint": "1) 配置 MODAL_TOKEN_ID / MODAL_TOKEN_SECRET；2) 确保本地存在 plugins/，服务端会在内存中扫描插件注解生成注册表；3) 确保本机可执行 `python -m modal`（如 pip install modal），再一键部署会根据该注册表对各个插件的 deploy.py 执行 modal deploy。完成后可点「重试」。",
				"modalDeployDismiss": "取消",
				"modalDeployAction": "下载并部署",
				"modalDeploying": "正在部署 Modal Workers…",
				"modalDeployDone": "部署完成",
				"modalDeployError": "部署失败",
				"modalDeployingAction": "部署中…",
				"modalDeployProgressHint": "已部署 {done}/{total}",
				"pluginImplementationTitle": "实现",
				"pluginModelTitle": "模型",
				"pluginParamsTitle": "高级参数",
				"pluginParamsReset": "重置",
				"pluginParamDefault": "默认 {value}",
				"pluginImplementationLoading": "正在加载插件实现列表…",
				"pluginImplementationEmpty": "未扫描到适用于该能力的插件实现。请在仓库的 plugins/ 目录下添加 Modal 或 API 插件（见 README），然后刷新页面。",
				"pluginRegistryLoadError": "无法加载插件注册表：{message}",
				"pluginSelectPlaceholder": "选择一个仓库…",
				"missingImplTitle": "未配置实现",
				"missingImplDescription": "该节点尚未安装可用插件（或未选择）。请先在插件管理中安装一个插件，或选择一个已安装的插件，然后再运行。"
			},
			"common": {
				"enterInstructions": "请输入指令...",
				"manualInput": "输入",
				"library": "素材库",
				"addText": "添加文本",
				"enterText": "输入文本内容...",
				"descOptional": "补充描述（可选）",
				"fromUpstreamText": "来自上游文本节点",
				"videoDesc": "视频描述",
				"aspectRatio": "宽高比",
				"resolution": "分辨率",
				"duration": "时长",
				"currentSize": "当前尺寸:",
				"currentDuration": "当前时长:",
				"upscaleTierLabel": "放大档位（输出长边）",
				"upscaleTierHint": "宽高比与输入一致，仅将长边放大至对应量级。",
				"upscaleTier1k": "1K · ~1920",
				"upscaleTier2k": "2K · ~2560",
				"upscaleTier4k": "4K · ~3840",
				"seconds": "秒",
				"minute": "分钟",
				"thinkingProcess": "思考过程",
				"performanceMode": "性能模式",
				"ecoMode": "💰 性价比模式",
				"proMode": "⚡ 高性能模式",
				"modelSelect": "模型",
				"models": {
					"imageEdit": "FLUX2 Klein 图片编辑",
					"imageGen": "Z-Image 文生图",
					"imageFusion": "FLUX2 Klein 图片融合",
					"imageGenVideo": "LTX2 图生视频",
					"features": {
						"gen-text": "默认（OpenRouter）",
						"gen-text-gemini": "Gemini",
						"gen-text-openai": "OpenAI",
						"split-text": "智能分段",
						"combine-text": "合并文本",
						"combine-text-openai": "合并文本（OpenAI）",
						"combine-text-gemini": "合并文本（Gemini）",
						"image-fusion": "FLUX2 Klein 融合",
						"image-gen-text": "图像描述",
						"video-gen-text": "视频描述",
						"transcribe": "语音转文字",
						"transcribe-timestamp": "语音转文字（带时间戳）",
						"concat-videos": "拼接视频",
						"extract-audio": "提取音轨",
						"remove-video-audio": "去除音频（无声视频）",
						"merge-video-audio": "音视频合并",
						"get-first-frame": "首帧",
						"get-last-frame": "尾帧",
						"parse-document": "文档解析",
						"split-video": "分镜切段",
						"link": "链接抓取",
						"gen-video": "文生视频",
						"image-gen": "Z-Image 文生图",
						"gen-music": "ACE-Step 音乐",
						"text-gen-speech-preset": "语音合成（预设风格）",
						"image-gen-video": "图生视频",
						"image-edit": "FLUX2 Klein 编辑",
						"image-upscale": "图像超分",
						"video-upscale": "视频超分",
						"image-describe": "图像理解",
						"video-describe": "视频理解",
						"audio-describe": "音频理解",
						"music-repaint": "音乐重绘",
						"music-cover": "音乐翻唱",
						"music-extract": "分离音轨",
						"music-lego": "添加乐轨",
						"music-complete": "补全编曲",
						"music-brief": "音乐企划",
						"audio-image-gen-video": "语音+图生视频",
						"speech-text-gen-video": "语音+文生视频",
						"video-image-gen-video-mix": "视频+图混合",
						"video-image-gen-video-move": "视频+图驱动",
						"image-image-gen-video": "图+图生视频",
						"text-gen-video": "文生视频",
						"image-gen-model": "图生3D",
						"speech-video-gen-video": "视频+台词配音对口型",
						"audio-video-lip-sync": "音频+视频对口型",
						"text-gen-speech-clone": "音色克隆",
						"text-gen-speech-instruct": "指令语音",
						"video-image-move-animal": "视频+图驱动（动物）",
						"video-image-move": "视频+图驱动（人物）",
						"video-image-move-muti": "视频+图驱动（多人）",
						"video-image-move-animal-muti": "视频+图驱动（动物，多人）",
						"wan-animate-mix": "WAN 混合动画",
						"subtitle-remove": "去字幕",
						"remove-watermark": "去水印",
						"denoise-audio": "降噪",
						"separate-audio-track": "人声伴奏分离",
						"separate-speaker": "说话人分离",
						"convert-voice": "音色替换",
						"drop-video": "筛选片段",
						"arrange-group": "批量编排"
					}
				},
				"voice": "音色",
				"selectVoice": "请选择音色",
				"previewVoice": "试听当前音色",
				"uploadVoice": "上传音色",
				"recordVoice": "录制音色",
				"voiceClone": "声音克隆",
				"voicePreset": "预设风格",
				"voiceDescribe": "自定义描述",
				"gender": "性别",
				"selectGender": "选择性别（可选）",
				"emotion": "情感",
				"style": "风格",
				"selectEmotion": "选择情感风格（可选）",
				"selectStyle": "选择语音风格（可选）",
				"voiceDescription": "声音描述",
				"voiceDescriptionPlaceholder": "请输入声音风格描述，例如：温柔甜美的女声，语速稍慢...",
				"referenceAudio": "参考音频",
				"noReferenceAudio": "请上传或录制一段参考音频（≥3 秒）",
				"referenceText": "参考文本",
				"referenceTextPlaceholder": "可选：参考音频的转写文本，有助于提升克隆质量",
				"referenceTextCloneHint": "不填则使用 x-vector 快速克隆；填写参考音频转写文本可启用更高质量的 ICL 克隆",
				"language": "语言",
				"inputText": "输入文本"
			},
			"titles": {
				"imageGenVideo": "图片生成视频",
				"textGenVideo": "文本生成视频",
				"addText": "添加文本",
				"textGenText": "文本生成文本",
				"combineText": "合并文本",
				"textGenImage": "文本生成图片",
				"textGenSpeechClone": "生成语音(克隆音色)",
				"textGenSpeechCloneCompose": "音色克隆（文本+参考音频）",
				"imageGenVideoCompose": "图生视频（文本+图片）",
				"textGenSpeechPreset": "生成语音(预设音色)",
				"textGenSpeechInstruct": "生成语音(描述音色)",
				"imageFusion": "图片融合",
				"videoUpscale": "视频高清放大",
				"videoGenText": "反推描述",
				"speechRecognize": "语音识别",
				"textGenMusic": "文本生成音乐",
				"speechGenVideo": "音频生成视频",
				"convertVoice": "人声替换",
				"denoiseAudio": "音频降噪",
				"fileGenText": "文档解析",
				"linkGenText": "链接提取",
				"removeSubtitle": "消除字幕",
				"removeWatermark": "去除水印",
				"separateAudio": "音视频分离",
				"imageGenText": "反推描述",
				"audioDescribe": "音频理解",
				"imageGenImage": "图片编辑",
				"videoEdit": "视频编辑",
				"imageGenModel": "图片生成3D模型",
				"imagePose": "姿态检测",
				"imageBodySeg": "人体部位分割",
				"imageNormal": "表面法线",
				"imageMatting": "人像抠图",
				"videoGenModel": "视频动作捕捉",
				"imageUpscale": "高清放大",
				"separateTrack": "人声提取",
				"separateSpeaker": "说话人分离",
				"separateSound": "声音分离",
				"speechImageGenVideo": "语音图片生成视频",
				"concatVideo": "视频拼接",
				"mergeVideoAudio": "音视频合并",
				"audioVideoLipSync": "视频对口型",
				"speechTextGenVideo": "语音文本生成视频",
				"speechVideoGenVideo": "视频配音对口型",
				"imageImageGenVideo": "首尾帧生成视频",
				"imagesGenVideo": "多图参考生视频",
				"refsGenVideo": "全模态参考生视频",
				"textAudioGenSpeech": "文本音频生成语音",
				"videoImageMix": "视频图片混合",
				"videoImageMove": "视频图片迁移",
				"splitVideo": "视频分割",
				"splitText": "智能拆分",
				"getFirstFrame": "首帧截图",
				"getLastFrame": "尾帧截图",
				"extractAudioTrack": "提取音轨",
				"removeVideoAudio": "去除音频（无声视频）",
				"musicRepaint": "音乐重绘",
				"musicCover": "音乐翻唱",
				"musicExtract": "分离音轨",
				"musicLego": "添加乐轨",
				"musicComplete": "补全编曲",
				"musicBrief": "音乐企划",
				"textGenAudio": "文本生成音频"
			},
			"options": {
				"portrait": "竖屏",
				"landscape": "宽屏",
				"square": "正方形",
				"standard": "标准",
				"verticalStandard": "竖标",
				"human": "人物",
				"animal": "动物",
				"single": "单人",
				"multi": "多人"
			},
			"actions": {
				"generateVideo": "生成视频",
				"generateImage": "生成图片",
				"generateSpeech": "生成语音",
				"startFusion": "开始融合",
				"convertText": "转换文本",
				"startUpscale": "开始放大",
				"describeVideo": "描述视频",
				"recognizeSpeech": "识别语音",
				"generateMusic": "生成音乐",
				"generateAudio": "生成音频",
				"startReplace": "开始替换",
				"startDenoise": "开始降噪",
				"parseDocument": "解析文档",
				"extractContent": "提取内容",
				"removeSubtitle": "消除字幕",
				"removeWatermark": "去除水印",
				"compressVideo": "压缩视频",
				"extractAudio": "开始分离",
				"describeImage": "描述图片",
				"describeAudio": "描述音频",
				"editImage": "编辑图片",
				"editVideo": "编辑视频",
				"generate3DModel": "生成3D模型",
				"detectPose": "检测姿态",
				"segmentBody": "分割人体部位",
				"estimateNormal": "估计法线",
				"extractForeground": "提取前景",
				"captureMotion": "捕捉动作",
				"imageUpscale": "高清放大",
				"extractVocals": "提取人声",
				"startSeparation": "开始分离",
				"concatVideo": "拼接视频",
				"startMerge": "开始合并",
				"lipDub": "配音对口型",
				"motionTrackGenerate": "按轨迹生成",
				"splitVideo": "分割视频",
				"splitText": "智能拆分",
				"getFirstFrame": "截取首帧",
				"getLastFrame": "截取尾帧",
				"extractAudioTrack": "提取音轨",
				"removeVideoAudio": "去除音频",
				"repaintMusic": "开始重绘",
				"coverMusic": "生成翻唱",
				"extractStem": "开始分离",
				"separateSound": "开始分离",
				"addTrack": "生成乐轨",
				"completeMusic": "开始补全",
				"musicBrief": "生成企划"
			},
			"params": {
				"prompt": "提示词",
				"model": "模型",
				"modelDefault": "默认 (OpenRouter 免费路由)",
				"geminiModel": "Gemini 模型",
				"openaiModel": "OpenAI 模型",
				"style": "风格",
				"sampler": "采样器",
				"seed": "种子",
				"steps": "步数",
				"cfg": "提示词相关性"
			},
			"emotions": {
				"none": "无",
				"happy": "开心",
				"angry": "生气",
				"sad": "伤心",
				"fear": "恐惧",
				"surprised": "惊讶",
				"confusion": "困惑",
				"empathy": "共情",
				"embarrass": "尴尬",
				"excited": "兴奋",
				"depressed": "氮丧",
				"admiration": "敬佩",
				"coldness": "冷淡"
			},
			"genders": {
				"none": "无",
				"male": "男声",
				"female": "女声"
			},
			"styles": {
				"none": "无",
				"serious": "严肃",
				"arrogant": "傲慢",
				"child": "童声",
				"older": "老年",
				"girl": "少女",
				"pure": "纯真",
				"sister": "御姐",
				"sweet": "甜美",
				"exaggerated": "夸张",
				"ethereal": "空灵",
				"whisper": "耳语",
				"generous": "豪爽",
				"recite": "朗诵",
				"act_coy": "撒娇",
				"warm": "温暖",
				"shy": "害羞",
				"comfort": "安慰",
				"authority": "权威",
				"chat": "闲聊",
				"radio": "电台",
				"soulful": "深情",
				"gentle": "温柔",
				"story": "故事",
				"vivid": "生动",
				"program": "主持",
				"news": "新闻",
				"advertising": "广告",
				"roar": "咆哮",
				"murmur": "低语",
				"shout": "呐喊",
				"deeply": "低沉",
				"loudly": "高亢"
			},
			"recorder": {
				"title": "录制音色",
				"desc": "录制一段音频作为语音合成的参考音色",
				"start": "开始录制",
				"stop": "停止录制",
				"preview": "试听",
				"retry": "重录",
				"uploading": "上传中...",
				"confirm": "确认使用",
				"cancel": "取消",
				"recording": "正在录制...",
				"recorded": "录制完成",
				"micError": "无法访问麦克风，请确保已授予权限",
				"uploadError": "上传失败，请重试",
				"uploadFailed": "上传失败"
			},
			"imageFusion": {
				"loading": "加载中...",
				"imageReference": "图片引用",
				"imageReferenceHint": "点击图片可在提示词中插入引用",
				"fusionPrompt": "融合提示词",
				"fusionPromptPlaceholder": "输入融合指令，例如：保持图1的风格、融合所有图片的特征、突出图2的色彩、结合图3的构图等",
				"imageLabel": "图"
			},
			"refsGenVideo": {
				"videoReference": "视频引用",
				"videoLabel": "视频",
				"audioReference": "音频引用",
				"audioLabel": "音频",
				"referenceHint": "最多 9 张图、3 段视频、3 段音频（共 12 个文件）；音频需搭配图片或视频。点击缩略图可在提示词中插入引用。",
				"promptPlaceholder": "描述想要的视频，例如：图1的角色用音频1的声音说话，场景延续视频1……"
			},
			"video": { "fileCount": "处理文件数:" },
			"speechRecognize": { "withTimestamp": "带时间戳" },
			"music": {
				"handleStyle": "曲风",
				"handleLyric": "歌词",
				"referenceAudio": "参考音频",
				"inputLyrics": "输入歌词",
				"audioDuration": "音频时长",
				"currentDuration": "当前时长:",
				"seconds": "秒",
				"15s": "15秒",
				"30s": "30秒",
				"1min": "1分钟",
				"2min": "2分钟",
				"styleSettings": "音乐风格",
				"voiceGender": "声音",
				"genders": {
					"male": "男声",
					"female": "女声"
				},
				"timbre": "音色",
				"timbres": {
					"bright": "明亮",
					"dark": "深沉",
					"warm": "温暖",
					"soft": "柔和",
					"rock": "摇滚",
					"vocal": "人声"
				},
				"genre": "流派",
				"genres": {
					"pop": "流行",
					"rock": "摇滚",
					"electronic": "电子",
					"hiphop": "嘻哈",
					"jazz": "爵士",
					"blues": "蓝调",
					"classical": "古典",
					"folk": "民谣",
					"country": "乡村",
					"rnb": "R&B",
					"kpop": "K-Pop",
					"reggae": "雷鬼",
					"soul": "灵魂乐",
					"dance": "舞曲",
					"rap": "说唱",
					"classicRock": "经典摇滚",
					"hardRock": "硬摇滚",
					"rockabilly": "乡村摇滚",
					"dancepop": "舞曲流行",
					"house": "浩室",
					"deephouse": "深浩室",
					"experimental": "实验音乐",
					"experimentalPop": "实验流行",
					"popPunk": "流行朋克",
					"rockAndRoll": "摇滚乐",
					"popRock": "流行摇滚"
				},
				"mood": "情感",
				"moods": {
					"happy": "欢快",
					"sad": "悲伤",
					"romantic": "浪漫",
					"melancholic": "忧郁",
					"uplifting": "振奋",
					"intense": "激烈",
					"emotional": "感性",
					"angry": "愤怒"
				},
				"instrumentAndRhythm": "乐器与节奏",
				"instrument": "乐器",
				"selectedCount": "已选 {count} 个",
				"instruments": {
					"piano": "钢琴",
					"guitar": "吉他",
					"acousticGuitar": "木吉他",
					"electricGuitar": "电吉他",
					"drums": "鼓",
					"synthesizer": "合成器",
					"violin": "小提琴",
					"saxophone": "萨克斯",
					"bass": "贝斯",
					"beats": "节拍采样",
					"strings": "弦乐",
					"cello": "大提琴",
					"trumpet": "小号",
					"harmonica": "口琴",
					"banjo": "班卓琴",
					"fiddle": "民间小提琴",
					"brass": "铜管乐器",
					"doubleBass": "低音提琴"
				},
				"bpm": "节拍速度",
				"slow": "慢",
				"moderate": "中等",
				"fast": "快",
				"songTitle": "歌曲名称",
				"songTitlePlaceholder": "输入歌曲名称（可选）",
				"noTagsSelected": "未选择标签",
				"tagsPlaceholder": "例如：female, pop, bright, piano, happy, 120bpm",
				"tagsHint": "输入音乐风格标签，用逗号分隔，如性别、流派、音色、乐器、情感、BPM等",
				"fromUpstreamReadonly": "来自上游（只读）",
				"lyricsPlaceholder": "输入歌词（未连接歌词输入时）",
				"language": "语言",
				"keyscale": "调式",
				"auto": "自动"
			},
			"musicTasks": {
				"promptLabel": "描述",
				"promptPlaceholder": "描述音乐风格、情绪、乐器…",
				"lyricsLabel": "歌词",
				"lyricsPlaceholder": "歌词（可选）…",
				"startTime": "开始（秒）",
				"endTime": "结束（秒）",
				"strength": "强度",
				"track": "乐轨",
				"tracks": "要添加的乐轨",
				"instrumental": "纯音乐",
				"ideaPlaceholder": "用一句话描述你想要的歌曲…",
				"sourceAudio": "原曲",
				"refAudio": "参考音频",
				"trackOptions": {
					"vocals": "人声",
					"backing_vocals": "和声",
					"drums": "鼓",
					"percussion": "打击乐",
					"bass": "贝斯",
					"guitar": "吉他",
					"keyboard": "键盘",
					"synth": "合成器",
					"strings": "弦乐",
					"brass": "铜管",
					"woodwinds": "木管",
					"fx": "音效"
				}
			},
			"speechGenVideo": {
				"loading": "加载中...",
				"inputContent": "输入内容",
				"audio": "音频",
				"connectAudioHint": "请连接音频节点或上传音频文件",
				"audioPromptLabel": "配音提示词",
				"audioPromptPlaceholder": "输入音频配音提示词"
			},
			"convertVoice": {
				"sourceAudio": "源音频",
				"referenceVoice": "参考音色",
				"connectHint": "连上要换声的音频，再连一段参考音色"
			},
			"removeWatermark": { "hint": "自动识别并去除 Sora 视频水印" },
			"videoGenText": {
				"promptLabel": "自定义提示词",
				"promptPlaceholder": "留空使用默认提示词，或输入自定义指令，例如：只描述视频中的对话内容..."
			},
			"imageGenText": {
				"promptLabel": "自定义提示词",
				"promptPlaceholder": "留空使用默认提示词，或输入自定义指令，例如：只描述画面主体、风格、文字内容..."
			},
			"audioDescribe": {
				"promptLabel": "自定义提示词",
				"promptPlaceholder": "留空使用默认提示词，或输入自定义指令，例如：描述这段音频的曲风、情绪、乐器或人声…"
			},
			"textGenText": { "instructions": "指令" },
			"lipDub": {
				"targetDialogue": "目标台词（提示词）",
				"targetDialoguePlaceholder": "写入完整提示词，需包含角色描述与要说的目标语言台词（模型不会自动翻译）",
				"promptHint": "输出分辨率跟随参考视频。台词宜写完整提示词（含角色与目标语言对白，模型不自动翻译），长度接近原片；仅支持单说话人。"
			},
			"motionTrack": {
				"connectHint": "请连接首帧图片、参考视频（自动提取并迁移其运动），以及文本提示词（仅描述外观/风格）。",
				"controlVideo": "参考视频",
				"promptPlaceholder": "描述外观与风格；运动从参考视频中自动提取。",
				"promptHint": "提示词仅描述外观与风格；运动会从参考视频自动提取。时长滑块用于裁剪参考视频长度。",
				"missing": "还需提供：{items}"
			},
			"lipSync": {
				"scenePrompt": "场景描述（可选）",
				"scenePromptPlaceholder": "描述画面与说话人，例如：一位女性对着镜头说话。口型由连接的音频驱动，不要在这里写台词全文。",
				"audioDrivenHint": "口型与配音由音频轨决定；音频时长宜与参考视频接近。输出默认 720p。"
			},
			"imageEdit": {
				"performanceMode": "性能模式",
				"ecoMode": "💰 性价比（FLUX.2 Klein 9B）",
				"proMode": "⚡ 高性能模式",
				"editInstruction": "编辑指令",
				"fromUpstream": "（来自上游节点）",
				"editPlaceholder": "输入图片编辑指令，例如：提高对比度、调整色温为暖色、增强细节等"
			},
			"videoEdit": {
				"editInstruction": "编辑指令",
				"fromUpstream": "（来自上游节点）",
				"editPlaceholder": "输入视频编辑指令，例如：去除字幕、应用水彩风格、将天空替换为日落",
				"connectTextVideo": "请连接文本节点与视频节点"
			},
			"compose": {
				"loading": "加载中...",
				"mediaFiles": "媒体文件",
				"image": "图片",
				"audio": "音频",
				"video": "视频",
				"text": "文本",
				"noText": "无文本",
				"inputContent": "输入内容",
				"videoFiles": "视频文件",
				"connectImageAudio": "请确保已连接一张图片和一个音频文件",
				"connectVideo": "请连接至少一个视频文件",
				"connectImageVideoAudio": "请确保已连接一张图片、一个视频和一个音频文件",
				"connectTextAudio": "请确保已连接文本内容和音频文件",
				"connectTextReferenceAudio": "请连接文本节点与音频节点（参考音色）",
				"connectTextImage": "请连接文本节点与图片节点",
				"connectTextVideoNode": "请连接视频节点与文本节点（目标台词写入提示词）",
				"referenceAudio": "参考音频",
				"referenceTextOptional": "参考文本（可选，提升克隆质量）",
				"connectVideoAudio": "请确保已连接视频和音频文件",
				"generatePromptLabel": "生成提示词",
				"generatePromptPlaceholder": "输入视频生成提示词，描述要生成的视频内容、风格、动作等（可选）",
				"inputText": "输入文本",
				"inputTextPlaceholder": "输入文本内容",
				"describeVideo": "请描述您想生成的视频内容...",
				"firstFrame": "首帧",
				"lastFrame": "尾帧",
				"connectTwoImages": "请确保已连接两张图片（首帧和尾帧）",
				"inputData": "输入数据",
				"connectTextAudioNode": "请连接文本和音频节点",
				"emotion": "情感：",
				"style": "风格：",
				"selectEmotion": "选择情感风格（可选）",
				"selectStyle": "选择语音风格（可选）",
				"lipSync": "对口型",
				"connectImageVideo": "请确保已连接一张图片和一个视频文件",
				"startSlice": "开始切片"
			},
			"modal": {
				"audioPreview": "音频预览",
				"audio": "音频",
				"audios": "音频 ({count})",
				"loading": "加载中...",
				"unavailable": "内容无法加载",
				"more": "更多",
				"moreOptions": "更多选项",
				"actions": "操作",
				"textPreview": "文本预览",
				"text": "文本",
				"texts": "文本 ({count})",
				"imagePreview": "图片预览",
				"image": "图片",
				"images": "图片 ({count})",
				"videoPreview": "视频预览",
				"video": "视频",
				"videos": "视频 ({count})",
				"file": "文件",
				"files": "文件 ({count})",
				"link": "链接",
				"links": "链接 ({count})",
				"fullScreenPreview": "全屏预览",
				"fullScreenWaterfall": "全屏瀑布流预览",
				"model3DPreview": "3D模型预览",
				"model3D": "3D模型",
				"models3D": "3D模型 ({count})",
				"resetView": "重置视图",
				"playAnimation": "播放动画",
				"pauseAnimation": "暂停动画",
				"downloadModel": "下载模型",
				"loading3DModel": "正在加载3D模型...",
				"errorLoadingModel": "模型加载出错",
				"dragToRotate": "左键拖拽旋转 | 滚轮缩放 | 点击重置居中",
				"noModelLoaded": "未加载3D模型",
				"loadingPreview": "加载预览中...",
				"unsupportedFormat": "不支持的格式",
				"supportedFormats": "支持的格式",
				"download": "下载",
				"textEditor": "编辑文本",
				"enterText": "请输入文本内容..."
			},
			"add": {
				"addAudio": "添加音频",
				"addImage": "添加图片",
				"addVideo": "添加视频",
				"addText": "添加文本",
				"addFile": "添加文件",
				"addModel": "添加3D模型",
				"addLink": "添加链接",
				"record": "录音",
				"recordVideo": "录像",
				"upload": "上传",
				"library": "素材库",
				"recorded": "已录制",
				"uploading": "上传中",
				"confirmAndUpload": "确认并上传",
				"dropToUpload": "释放文件以上传",
				"dragOrClick": "拖拽文件到此处或点击上传",
				"supportedAudioFormats": "支持 MP3, WAV, OGG, M4A 格式",
				"supportedImageFormats": "支持常见图片格式",
				"supportedVideoFormats": "支持 MP4, MOV, WEBM 格式",
				"browseFiles": "浏览文件",
				"canvas": "涂鸦",
				"camera": "相机",
				"openCanvas": "打开涂鸦板",
				"canvasDrawing": "涂鸦绘制",
				"canvasDrawingHint": "在下面的画板上绘制，然后点击完成保存",
				"clearCanvas": "清空画布",
				"finishAndSave": "完成并保存",
				"clickToStartCamera": "点击启动相机",
				"takePhoto": "拍照",
				"closeCamera": "关闭相机",
				"cameraError": "无法访问摄像头",
				"cameraErrorHint": "请确保：1. 使用HTTPS或localhost 2. 允许摄像头权限 3. 摄像头未被其他应用占用",
				"inputText": "输入文本",
				"textPlaceholder": "请输入文本内容...",
				"generate": "确认",
				"linkPlaceholder": "请输入链接",
				"extractContent": "提取内容",
				"cancel": "取消",
				"startRecordingVideo": "开始录制视频",
				"addDocument": "添加文档",
				"supportedDocFormats": "支持多种文档格式",
				"dragModel": "拖拽3D模型文件到此处或点击上传",
				"supportedModelFormats": "支持格式",
				"modelHint": "提示: 支持以下3D文件格式："
			},
			"batch": {
				"arrangeGroup": "排列组合",
				"startArrange": "开始排列",
				"describeRequirements": "请描述您的要求...",
				"groupCount": "分组数量",
				"allowDuplicate": "允许重复",
				"videoFilter": "视频筛选",
				"startFilter": "开始筛选"
			},
			"voice": {
				"timbre": "音色：",
				"selectTimbre": "请选择音色",
				"previewTimbre": "试听当前音色",
				"uploadTimbre": "上传音色",
				"recordTimbre": "录制音色",
				"emotion": "情感：",
				"replaceTimbre": "替换音色"
			},
			"separateSound": {
				"textLabel": "要提取的声音",
				"textPlaceholder": "如:狗叫、钢琴、背景里的警笛"
			},
			"textGenAudio": {
				"voiceReference": "参考音色",
				"promptLabel": "音频描述",
				"promptPlaceholder": "把整段场景写出来：谁在说话、怎么说，背景环境，音效。台词用引号，例如：@voice1 说：“今天天气真好。”窗外下着小雨。",
				"hint": "一次生成人声、音效和环境声。最多连 3 段音频作参考音色，点一下就把 @voice1…@voice3 插进描述里。"
			}
		}
	},
	Upload: {
		"failed": "上传失败，请稍后重试",
		"fileFailed": "文件 \"{name}\" 上传失败：{reason}",
		"partialFailed": "部分或全部文件上传失败",
		"maxFilesExceeded": "最多允许 {max} 个文件",
		"fileTooLarge": "文件 \"{name}\" 过大（上限 {max}MB）",
		"fileTypeNotAccepted": "文件 \"{name}\" 类型不被支持",
		"readImageFailed": "读取图片信息失败",
		"readVideoFailed": "读取视频信息失败"
	},
	LibInput: {
		"deleteSuccess": "素材已删除",
		"deleteFailed": "删除失败",
		"emptyText": "空文本",
		"loadFailed": "加载素材失败",
		"added": "已添加素材",
		"retry": "重试",
		"emptyMaterial": "暂无{type}素材",
		"typeImage": "图片",
		"typeVideo": "视频",
		"typeAudio": "音频",
		"typeText": "文本",
		"typeFile": "文件",
		"typeModel": "模型",
		"favoriteHint": "点击节点上的 ❤️ 图标收藏素材",
		"portfolio": "作品集"
	},
	Recorder: {
		"audioStart": "开始录音",
		"audioCancel": "取消",
		"audioCancelTooltip": "取消录音",
		"audioFinish": "完成",
		"audioFinishTooltip": "完成录音",
		"audioPermissionError": "无法访问麦克风。请确保已授予权限。",
		"videoPermissionError": "无法访问摄像头和麦克风。请确保已授予权限。",
		"videoStart": "开始录制",
		"videoStop": "停止录制"
	},
	Languages: {
		"auto": "自动",
		"zh": "中文",
		"ja": "日本語",
		"yue": "粤语",
		"en": "英语",
		"ko": "韩语",
		"fr": "法语",
		"es": "西班牙语",
		"de": "德语",
		"ru": "俄语",
		"pt": "葡萄牙语",
		"it": "意大利语"
	},
	Errors: {
		"somethingWentWrong": "出现错误",
		"tryAgain": "重试",
		"details": "详情",
		"copy": "复制",
		"copied": "已复制",
		"close": "关闭",
		"openModalBilling": "打开 Modal 账单设置",
		"needHelp": "解决不了？来社群里找我们：",
		"wechatGroup": "微信群",
		"wechatQrAlt": "微信群二维码"
	},
	Api: {
		"unknownError": "未知错误",
		"unauthorized": "未授权",
		"accessDenied": "拒绝访问",
		"requestFailed": "请求失败：{status} {statusText}",
		"success": "操作成功",
		"timedOut": "请求超时，请重试"
	}
};
//#endregion
//#region src/canvas/i18n/messages.ts
/**
* Message catalogs the canvas ships with. A host merges the catalog for its
* locale into its own messages (`{ ...canvasMessages[locale], ...own }`) and
* provides them through `use-intl`'s `IntlProvider` (or next-intl's
* `NextIntlClientProvider`, which is the same context).
*/
const CANVAS_LOCALES = [
	"en",
	"zh",
	"ja",
	"ko"
];
const canvasMessages = {
	en: en_default,
	zh: zh_default,
	ja: ja_default,
	ko: ko_default
};
function isCanvasLocale(value) {
	return CANVAS_LOCALES.includes(value);
}
//#endregion
export { CANVAS_LOCALES, canvasMessages, isCanvasLocale };
